<template>
  <div>
    <!-- <AddEmailToBranch :branchId="branchId"></AddEmailToBranch> -->
    <MasterLayout>
      <section class="row card-loader-wrapper w-100" v-if="showLoader">
        <div class="col-md-3 position-relative" v-for="(c, i) in 4" :key="i">
          <div class="card-loader"></div>
        </div>

        <!-- LOADER -->
        <div class="showLoaderDiv charts__loader w-full mt-5 rounded-lg w-full">
          <div :class="showLoader ? 'loading' : null"></div>
        </div>
        <!-- END LOADER -->
      </section>

      <section class="dashboard_first_row mb-5" v-if="!showLoader">
        <!-- <img src="@/assets/img/ReferBanner.png" class="remisAD" /> -->
        <div
          class="d-flex justify-content-between align-middle flex-lg-row flex-md-row date-picker mx-auto pt-3"
        >
          <h5
            style="font-size: 1.1rem; padding-top: 20px; display: block"
            v-if="!showLoader"
          >
            {{ $t("text.bDashboard.salesReport") }}
          </h5>

          <div class="drop_down_div align-items-center">
            <vue-ctk-date-time-picker
              v-model="generalDateRange"
              :max-date="generalMaxDate"
              :range="true"
              :autoClose="true"
              :locale="this.$root.$i18n.locale"
              :custom-shortcuts="customShortcuts"
              :color="$store.getters.getDatePickerColor"
              format="DDMMYYYY"
              formatted="DD/MM/YYYY"
              :label="$t('text.calendar.dateRange')"
            />
          </div>
        </div>

        <!-- TOP GRAPH CARD DIV STARTS-->
        <div class="row scoll-pane position-relative" id="scoll-pane">
          <div
            class="col-md-3 card_row"
            :class="productCount"
            v-if="hasPms && !pmsCond"
          >
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header">
                    {{ countryProducts.products.product1 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="stations_card_header">
                    {{ convertThousand(pmsSummary.volume) }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="text-right col-lg-12 col-md-12 col-sm-12">
                  <highcharts :options="pmsSplineOption" class=""></highcharts>
                </div>
              </div>
              <div class="clearfix">
                <div class="left_div">
                  <h4
                    class="percent__text"
                    v-bind:style="{ '--a': pmsRateColor }"
                  >
                    <span>
                      <img v-if="pmsUp" src="@/assets/img/arrowUp.svg" />
                      <img v-if="!pmsUp" src="@/assets/img/arrowDown.svg" />
                    </span>
                    {{ `${pmsRate}%` }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="dashboard__footer__amount" style="font-size: 23px">
                    {{ branch ? branch.currencyCode : "" }}
                    {{ convertThousand(pmsSummary.amount) }}
                    <!-- {{ $n(pmsSummary.amount, "currency") }} -->
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-3 remove-padding-left card_row"
            v-if="!hasPms && !getting"
          >
            <div class="mt-3 card_container_greyed dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h5 class="percent__text">{{ $t("text.bDashboard.na") }}</h5>
                </div>
                <div class="right_div">
                  <h5 class="percent__text">{{ $t("text.bDashboard.na") }}</h5>
                </div>
              </div>

              <div class="clearfix">
                <div class="pl-3 mt-2 mb-3">
                  <div class="text-right col-lg-12 col-md-12 col-sm-12">
                    <hr />
                  </div>
                </div>
                <div class="left_div">
                  <h5 class="percent__text">{{ $t("text.bDashboard.na") }}</h5>
                </div>
                <div class="right_div">
                  <h5 class="percent__text">{{ $t("text.bDashboard.na") }}</h5>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-3 card_row"
            :class="productCount"
            v-if="hasAgo && !agoCond"
          >
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_1">
                    {{ countryProducts.products.product2 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="stations_card_header_1">
                    {{ convertThousand(agoSummary.volume) }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="text-right col-lg-12 col-md-12 col-sm-12">
                  <highcharts :options="agoSplineOption" class=""></highcharts>
                </div>
              </div>
              <div class="clearfix">
                <div class="left_div">
                  <h4
                    class="percent__text"
                    v-bind:style="{ '--a': agoRateColor }"
                  >
                    <span>
                      <img v-if="agoUp" src="@/assets/img/arrowUp.svg" />
                      <img v-if="!agoUp" src="@/assets/img/arrowDown.svg" />
                    </span>
                    {{ `${agoRate}%` }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="dashboard__footer__amount_1"
                    style="font-size: 23px"
                  >
                    {{ branch ? branch.currencyCode : "" }}
                    {{ convertThousand(agoSummary.amount) }}
                    <!-- {{ $n(agoSummary.amount, "currency") }} -->
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-3 remove-padding-left card_row"
            v-if="!hasAgo && !getting"
          >
            <div class="mt-3 card_container_greyed dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h5 class="percent__text">{{ $t("text.bDashboard.na") }}</h5>
                </div>
                <div class="right_div">
                  <h5 class="percent__text">{{ $t("text.bDashboard.na") }}</h5>
                </div>
              </div>

              <div class="clearfix">
                <div class="pl-3 mt-2 mb-3">
                  <div class="text-right col-lg-12 col-md-12 col-sm-12">
                    <hr />
                  </div>
                </div>
                <div class="left_div">
                  <h5 class="percent__text">{{ $t("text.bDashboard.na") }}</h5>
                </div>
                <div class="right_div">
                  <h5 class="percent__text">{{ $t("text.bDashboard.na") }}</h5>
                </div>
              </div>
            </div>
          </div>
          <div
            class="col-md-3 card_row"
            :class="productCount"
            v-if="hasDpk && !dpkCond"
          >
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_2">
                    {{ countryProducts.products.product3 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="stations_card_amount_header_3">
                    {{ convertThousand(dpkSummary.volume) }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="text-right col-lg-12 col-md-12 col-sm-12">
                  <highcharts :options="dpkSplineOption" class=""></highcharts>
                </div>
              </div>
              <div class="clearfix">
                <div class="left_div">
                  <h4
                    class="percent__text"
                    v-bind:style="{ '--a': dpkRateColor }"
                  >
                    <span>
                      <img v-if="dpkUp" src="@/assets/img/arrowUp.svg" />
                      <img v-if="!dpkUp" src="@/assets/img/arrowDown.svg" />
                    </span>
                    {{ `${dpkRate}%` }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="dashboard__footer__amount_2"
                    style="font-size: 23px"
                  >
                    {{ branch ? branch.currencyCode : "" }}
                    {{ convertThousand(dpkSummary.amount) }}
                    <!-- {{ $n(dpkSummary.amount, "currency") }} -->
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-md-3 card_row"
            :class="productCount"
            v-if="hasLpg && !lpgCond"
          >
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_2" style="color: purple">
                    {{ countryProducts.products.product4 }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="stations_card_amount_header_3"
                    style="color: purple"
                  >
                    {{ convertThousand(lpgSummary.volume) }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="text-right col-lg-12 col-md-12 col-sm-12">
                  <highcharts :options="lpgSplineOption" class=""></highcharts>
                </div>
              </div>
              <div class="clearfix">
                <div class="left_div">
                  <h4
                    class="percent__text"
                    v-bind:style="{ '--a': lpgRateColor }"
                  >
                    <span>
                      <img v-if="lpgUp" src="@/assets/img/arrowUp.svg" />
                      <img v-if="!lpgUp" src="@/assets/img/arrowDown.svg" />
                    </span>
                    {{ `${lpgRate}%` }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="dashboard__footer__amount_2"
                    style="font-size: 23px; color: purple"
                  >
                    {{ branch ? branch.currencyCode : "" }}
                    {{ convertThousand(lpgSummary.amount) }}
                    <!-- {{ $n(lpgSummary.amount, "currency") }} -->
                  </h4>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3 card_row" :class="productCount">
            <div class="mt-3 card_container_1 dashboard_card_1">
              <div class="clearfix">
                <div class="left_div">
                  <h4 class="stations_card_header_3">
                    {{ $t("text.products.total") }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4 class="stations_card_amount_header_4">
                    {{
                      convertThousand(
                        pmsSummary.volume +
                          agoSummary.volume +
                          dpkSummary.volume +
                          lpgSummary.volume
                      )
                    }}
                  </h4>
                </div>
              </div>
              <div class="mt-2 row dashboard_card">
                <div class="text-right col-lg-12 col-md-12 col-sm-12">
                  <highcharts
                    :options="totalSplineOption"
                    class=""
                  ></highcharts>
                </div>
              </div>
              <div class="clearfix">
                <div class="left_div">
                  <h4
                    class="percent__text"
                    v-bind:style="{ '--a': totalRateColor }"
                  >
                    <span>
                      <img v-if="totalUp" src="@/assets/img/arrowUp.svg" />
                      <img v-if="!totalUp" src="@/assets/img/arrowDown.svg" />
                    </span>
                    {{ `${totalRate}%` }}
                  </h4>
                </div>
                <div class="right_div">
                  <h4
                    class="dashboard__footer__amount_3"
                    style="font-size: 23px"
                  >
                    {{ branch ? branch.currencyCode : "" }}
                    {{
                      convertThousand(
                        pmsSummary.amount +
                          agoSummary.amount +
                          dpkSummary.amount +
                          lpgSummary.amount
                      )
                    }}
                    <!-- {{
                    $n(
                      pmsSummary.amount +
                        agoSummary.amount +
                        dpkSummary.amount +
                        lpgSummary.amount,
                      "currency"
                    )
                  }} -->
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- TOP GRAPH CARD DIV ENDS-->

        <!-- NAV ARROWS FOR GRAPH CARDS -->
        <div v-if="prodCounts > 3 && lpgCond == false">
          <div
            @click="arrowLeft"
            @mouseover="arrowLeft"
            class="position-absolute rounded-circle arrow-div-left"
          >
            <img
              class="arrowpics"
              src="@/assets/img/arrowLeft.png"
              width="40px"
            />
          </div>
          <div
            @click="arrowRight"
            @mouseover="arrowRight"
            class="position-absolute rounded-circle arrow-div-right"
          >
            <img
              class="arrowpics"
              src="@/assets/img/arrowRight.png"
              width="40px"
            />
          </div>
        </div>
      </section>

      <!-- OLD DASHBOARD STARTS HERE -->
      <section
        v-if="
          userInfo.roles.includes('Old Client') ||
          userInfo.email == 'supportest@gmail.com'
        "
        class="mt-5 section_3 last__ten__transactions__row"
      >
        <div class="row" style="margin-top: -20px">
          <div class="col-md-12 col-lg-8 table_block">
            <!-- TOTAL TANKS CONSUMPTION REPORT -->

            <h5
              style="font-size: 1.1rem; margin-bottom: -5px; padding-left: 10px"
            >
              {{
                hasTankStockPms ||
                hasTankStockAgo ||
                hasTankStockDpk ||
                hasTankStockLpg
                  ? $t("text.cDashboard.productInventory")
                  : " "
              }}
            </h5>
            <div class="row mb-2 pos_trans_card_holder" v-if="!showLoader">
              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount]"
                v-if="hasTankStockPms"
              >
                <!-- <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount, LGgridNum, MDgridNum]"
                v-if="hasTankStockPms"
              > -->
                <div
                  class="card_container_1 pos-card mt-3 card-vertical-center"
                >
                  <h4 class="stations_card_header">
                    {{ countryProducts.products.product1 }}
                  </h4>
                  <div class="oil_drop_div_1">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h4 style="font-size: 1.3rem">
                      {{ convertThousand(pmsTankStock.volume) }}Ltrs
                    </h4>
                  </div>
                </div>
              </div>
              <!-- NO PMS N/A -->
              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="productCount"
                v-if="!hasTankStockPms"
              >
                <div
                  class="card_container_greyed pos-card mt-3 card-vertical-center"
                >
                  <h5 class="stations_card_header disabled-text">PMS</h5>
                  <div class="oil_drop_div_1 disabled-label-bg">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h5 class="">N/A</h5>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount]"
                v-if="hasTankStockAgo"
                v-show="userDetails.email !== 'supportest@gmail.com'"
              >
                <!-- <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount, LGgridNum, MDgridNum]"
                v-if="hasTankStockAgo"
              > -->
                <div
                  class="card_container_1 pos-card mt-3 card-vertical-center"
                >
                  <h5 class="stations_card_header_1">
                    {{ countryProducts.products.product2 }}
                  </h5>
                  <div class="oil_drop_div_2">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h4 style="font-size: 1.3rem">
                      {{ convertThousand(agoTankStock.volume) }}Ltrs
                    </h4>
                  </div>
                </div>
              </div>
              <!-- NO AGO N/A -->
              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="productCount"
                v-if="!hasTankStockAgo"
                v-show="userDetails.email !== 'supportest@gmail.com'"
              >
                <div
                  class="card_container_greyed pos-card mt-3 card-vertical-center"
                >
                  <h5 class="stations_card_header disabled-text">AGO</h5>
                  <div class="oil_drop_div_1 disabled-label-bg">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h5 class="">N/A</h5>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount]"
                v-if="hasTankStockDpk"
                v-show="userDetails.email !== 'supportest@gmail.com'"
              >
                <!-- <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount, LGgridNum, MDgridNum]"
                v-if="hasTankStockDpk"
              > -->
                <div
                  class="card_container_1 pos-card mt-3 card-vertical-center"
                >
                  <h4 class="stations_card_header_2">
                    {{ countryProducts.products.product3 }}
                  </h4>
                  <div class="oil_drop_div_3">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h4 style="font-size: 1.3rem">
                      {{ convertThousand(dpkTankStock.volume) }}Ltrs
                    </h4>
                  </div>
                </div>
              </div>

              <!-- NO DPK N/A -->
              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="productCount"
                v-if="!hasTankStockDpk"
                v-show="userDetails.email !== 'supportest@gmail.com'"
              >
                <div
                  class="card_container_greyed pos-card mt-3 card-vertical-center"
                >
                  <h5 class="stations_card_header disabled-text">DPK</h5>
                  <div class="oil_drop_div_1 disabled-label-bg">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h5 class="">N/A</h5>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount]"
                v-if="hasTankStockLpg"
                v-show="userDetails.email !== 'supportest@gmail.com'"
              >
                <!-- <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount, LGgridNum, MDgridNum]"
                v-if="hasTankStockLpg"
              > -->
                <div
                  class="card_container_1 pos-card mt-3 card-vertical-center"
                >
                  <h4 class="stations_card_header_1" style="color: purple">
                    {{ countryProducts.products.product4 }}
                  </h4>
                  <div class="oil_drop_div_4" style="background: purple">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h4 style="font-size: 1.3rem">
                      {{ convertThousand(lpgTankStock.volume) }}Ltrs
                    </h4>
                    <small class="dashboard__card__header_bottom"> </small>
                  </div>
                </div>
              </div>

              <!-- NO LPG N/A -->
              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="productCount"
                v-if="!hasTankStockLpg"
                v-show="userDetails.email !== 'supportest@gmail.com'"
              >
                <div
                  class="card_container_greyed pos-card mt-3 card-vertical-center"
                >
                  <h5 class="stations_card_header disabled-text">LPG</h5>
                  <div class="oil_drop_div_1 disabled-label-bg">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h5 class="">N/A</h5>
                  </div>
                </div>
              </div>
            </div>

            <div class="section_3_table_section mt-3">
              <div class="row py-5">
                <div class="col-md-8">
                  <h3 class="ml-2 sales_vs_target_header">
                    {{ $t("text.bDashboard.salesVTarget") }}
                  </h3>
                </div>

                <div class="col-md-4 section___column_2">
                  <div class="align-items-center">
                    <div class="">
                      <div class="mt-2 mr-2 drop_down_section">
                        <div
                          class="align-items-center"
                          style="border-bottom: 1px solid grey"
                        >
                          <vue-ctk-date-time-picker
                            id="first_date_picker"
                            v-model="dateRange1"
                            :max-date="maxDate"
                            :onlyDate="true"
                            :autoClose="true"
                            :locale="this.$root.$i18n.locale"
                            :color="$store.getters.getDatePickerColor"
                            format="DDMMYYYY"
                            formatted="DD/MM/YYYY"
                            :label="$t('text.calendar.selectDate')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="mt-5 highcharts__row">
                <div class="mt-5 row">
                  <div class="col-md-4" :class="salesTargetCount" v-if="hasPms">
                    <div class="highcharts__div">
                      <highcharts
                        :options="pmsGuageOptions"
                        class=""
                      ></highcharts>
                    </div>
                  </div>
                  <div
                    class="col-md-4"
                    :class="salesTargetCount"
                    v-if="!hasPms && !getting"
                  >
                    <div class="greyed_pie_chart_holder">
                      <highcharts
                        :options="greyedGuageOptions"
                        class=""
                      ></highcharts>
                      <div class="empty_chart_text">
                        <p>N/A</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4" :class="salesTargetCount" v-if="hasAgo">
                    <div class="highcharts__div">
                      <highcharts
                        :options="agoGuageOptions"
                        class=""
                      ></highcharts>
                    </div>
                  </div>
                  <div
                    class="col-md-4"
                    :class="salesTargetCount"
                    v-if="!hasAgo && !getting"
                  >
                    <div class="greyed_pie_chart_holder">
                      <highcharts
                        :options="greyedGuageOptions"
                        class=""
                      ></highcharts>
                      <div class="empty_chart_text">
                        <p>N/A</p>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4" :class="salesTargetCount" v-if="hasDpk">
                    <div class="highcharts__div">
                      <highcharts
                        :options="dpkGuageOptions"
                        class=""
                      ></highcharts>
                    </div>
                  </div>

                  <div class="col-md-4" :class="salesTargetCount" v-if="hasLpg">
                    <div class="highcharts__div">
                      <highcharts
                        :options="lpgGuageOptions"
                        class=""
                      ></highcharts>
                    </div>
                  </div>
                </div>
                <div class="mt-5 legend__div">
                  <div class="mt-5 row">
                    <div class="col-md-6">
                      <div class="row">
                        <div
                          class="col-md-3"
                          v-if="hasPms"
                          :class="salesTargetCount"
                        >
                          <div class="row align-items-center">
                            <div class="col-md-3">
                              <div
                                style="
                                  height: 10px;
                                  width: 30px;
                                  background: rgb(216, 153, 28);
                                "
                              ></div>
                            </div>
                            <div class="col-md-6">
                              <div style="display: flex; align-items: center">
                                <div style="color: rgb(216, 153, 28)">
                                  {{ countryProducts.products.product1 }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-md-3"
                          v-if="hasAgo"
                          :class="salesTargetCount"
                        >
                          <div class="row align-items-center">
                            <div class="col-md-3">
                              <div
                                style="
                                  height: 10px;
                                  width: 30px;
                                  background: rgb(155, 242, 36);
                                "
                              ></div>
                            </div>
                            <div class="col-md-6">
                              <div style="display: flex; align-items: center">
                                <div style="color: rgb(155, 242, 36)">
                                  {{ countryProducts.products.product2 }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-md-3"
                          v-if="hasDpk"
                          :class="salesTargetCount"
                        >
                          <div class="row align-items-center">
                            <div class="col-md-3">
                              <div
                                style="
                                  height: 10px;
                                  width: 30px;
                                  background: rgb(0, 172, 237);
                                "
                              ></div>
                            </div>
                            <div class="col-md-6">
                              <div style="display: flex; align-items: center">
                                <div style="color: rgb(0, 172, 237)">
                                  {{ countryProducts.products.product3 }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-md-3"
                          v-if="hasLpg"
                          :class="salesTargetCount"
                        >
                          <div class="row align-items-center">
                            <div class="col-md-3">
                              <div
                                style="
                                  height: 10px;
                                  width: 30px;
                                  background: purple;
                                "
                              ></div>
                            </div>
                            <div class="col-md-6">
                              <div style="display: flex; align-items: center">
                                <div style="color: purple">
                                  {{ countryProducts.products.product4 }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="text-right col-md-6"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="col-lg-4 col-sm-12 mt-5 drivers_block spread dashboard_left"
            style="height: 100%"
          >
            <div class="row remove_padding mobile_tiles" style="height: 16%">
              <div
                v-show="userInfo.email !== 'supportest@gmail.com'"
                class="pl-3 text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_right_desk"
              >
                <router-link
                  :to="{
                    name: 'tanks',
                    query: this.$route.query.branchId
                      ? {
                          branchId: this.$route.query.branchId,
                          companyId: $route.query.companyId,
                          dealerId: this.$route.query.dealerId,
                          groupId: this.$route.query.groupId,
                          regionId: this.$route.query.regionId,
                        }
                      : null,
                  }"
                  class="router_link__text"
                >
                  <div
                    class="py-4 section_3_right_column_block new_tiles"
                    style="height: 110%"
                  >
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.bDashboard.tanksInStation") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ tanksCount }}
                      </h3>
                    </div>
                  </div>
                </router-link>
              </div>

              <div
                class="text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_left_desk"
              >
                <router-link
                  :to="{
                    name: 'pumps',
                    query: this.$route.query.branchId
                      ? {
                          branchId: this.$route.query.branchId,
                          companyId: $route.query.companyId,
                          dealerId: this.$route.query.dealerId,
                          groupId: this.$route.query.groupId,
                          regionId: this.$route.query.regionId,
                        }
                      : null,
                  }"
                  class="router_link__text"
                >
                  <div
                    class="py-4 section_3_right_column_block new_tiles"
                    style="height: 110%"
                  >
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.bDashboard.pumpsInStation") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ pumpsCount }}
                      </h3>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
            <div
              class="row remove_padding mobile_tiles"
              style="margin-top: 33px; width: 98%"
            >
              <div
                class="text-center col-md-12 col-sm-12 text_div_block lnk mobile_under_tile padding_right_desk"
              >
                <router-link
                  :to="{
                    name: 'branch_tanks_filled',
                    query: this.$route.query.branchId
                      ? {
                          branchId: this.$route.query.branchId,
                          companyId: $route.query.companyId,
                          dealerId: this.$route.query.dealerId,
                          groupId: this.$route.query.groupId,
                          regionId: this.$route.query.regionId,
                        }
                      : null,
                  }"
                  class="router_link__text"
                >
                  <div class="py-4 section_3_right_column_block new_tiles">
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.bDashboard.tanksFilled") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ tanksFilled }}
                      </h3>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>

            <div
              v-if="userInfo.email == 'supportest@gmail.com'"
              class="row remove_padding mobile_under_tile tile_padding_top daily_count mt-3"
              style="margin-bottom: 0px"
            >
              <div class="text-center col-md-12 text_div_block lnk">
                <div
                  class="py-4 section_3_right_column_block"
                  style="height: 82%"
                >
                  <div class="">
                    <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                      {{ $t("text.bDashboard.dailyTcount") }}
                    </h3>

                    <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                      {{ $t("text.cDashboard.pms") }}
                    </h3>
                  </div>
                  <div class="">
                    <h3
                      class="my-4 stations__block_text_1 mobile_font"
                      style="font-size: 45px"
                    >
                      {{ PMSTransactionCount }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-else
              class="row remove_padding mobile_under_tile tile_padding_top daily_count mt-3"
              style="margin-bottom: 0px"
            >
              <div class="text-center col-md-12 text_div_block lnk">
                <div
                  class="py-4 section_3_right_column_block"
                  style="height: 82%"
                >
                  <div class="">
                    <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                      {{ $t("text.bDashboard.dailyTcount") }}
                    </h3>

                    <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                      {{ $t("text.bDashboard.pmsAgo") }} /
                      {{ $t("text.cDashboard.lpg") }}
                    </h3>
                  </div>
                  <div class="">
                    <h3
                      class="my-4 stations__block_text_1 mobile_font"
                      style="font-size: 45px"
                    >
                      {{ PMSTransactionCount }} / {{ AGOTransactionCount }} /
                      {{ LPGTransactionCount }}
                    </h3>
                  </div>
                </div>
              </div>
            </div>

            <!-- ESITIMATED PUMP CALIBRATION (TO BE ADDED) -->
            <!-- <div
							class="row remove_padding mobile_under_tile tile_padding_top"
							style="margin-top: -55px"
						>
							<div class="text-center col-md-12 text_div_block lnk">
								<router-link
									:to="{
										name:
											calibrationType === 'array' ? 'pumps_calibration' : null,
										query: this.$route.query.branchId
											? {
													branchId: this.$route.query.branchId,
													companyId: $route.query.companyId,
                          dealerId: this.$route.query.dealerId,
                          groupId: this.$route.query.groupId,
                          regionId: this.$route.query.regionId,
											  }
											: null,
									}"
									class="router_link__text"
									:class="
										calibrationType === 'number' ? 'disabledCursor' : null
									"
								>
									<div
										class="py-4 section_3_right_column_block"
										style="height: 90%; margin-top: 20px"
									>
										<div class="">
											<h3 class="mt-1 stations__block_text_1 mobile_title_font">
												{{ $t("text.bDashboard.estimatedPumpsCalibration") }}
											</h3>
											<div class="">
												<h3
													class="mt-4 stations__block_text_1 mobile_font"
													style="font-size: 40px"
													:class="
														calibrationType === 'number'
															? 'disabledColor'
															: null
													"
												>
													{{ averagePumpsCalibrationRatio }}
												</h3>
											</div>
										</div>
									</div>
								</router-link>
							</div>
						</div> -->
          </div>
        </div>

        <div class="mt-5 row mobile_marg_ri">
          <div class="col-lg-4 col-sm-12 padding_right_desk">
            <router-link
              :to="{
                name: 'pump_fault',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="router_link__text"
            >
              <div
                class="py-3 section_3_right_column_block mobile_dis_height"
                style="height: 135px; text-align: center"
              >
                <div class="">
                  <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                    {{ $t("text.bDashboard.pumpsFault") }}
                  </h3>
                </div>
                <div class="">
                  <h3
                    class="mt-4 stations__block_text_1 mobile_font"
                    style="font-size: 40px"
                  >
                    {{ pumpsFault }}
                  </h3>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-4 col-sm-12 padding_left_desk padding_right_desk">
            <router-link
              :to="{
                name: 'branch_disconnected_pumps',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="router_link__text"
            >
              <div
                class="py-3 section_3_right_column_block mobile_dis_height"
                style="height: 135px; text-align: center"
              >
                <div class="">
                  <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                    {{ $t("text.bDashboard.disconnectedPumps") }}
                  </h3>
                </div>
                <div class="">
                  <h3
                    class="mt-4 stations__block_text_1 mobile_font"
                    style="font-size: 40px"
                  >
                    {{ offlinePumps }}
                  </h3>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-4 col-sm-12 padding_left_desk">
            <router-link
              :to="{
                name: 'branch_offline_pumps',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="router_link__text"
            >
              <div
                class="py-3 section_3_right_column_block mobile_dis_height"
                style="height: 135px; text-align: center"
              >
                <div class="">
                  <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                    {{ $t("text.bDashboard.offlinePumps") }}
                  </h3>
                </div>
                <div class="">
                  <h3
                    class="mt-4 stations__block_text_1 mobile_font"
                    style="font-size: 40px"
                  >
                    {{ deviceNotPushing }}
                  </h3>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </section>
      <!-- OLD DASHBOARD ENDS HERE -->

      <!-- NEW DASHBOARD STARTS HERE -->
      <section v-else class="mt-5 section_3 last__ten__transactions__row">
        <div class="row" style="margin-top: -20px">
          <div class="col-md-12 col-lg-7 table_block">
            <!-- TOTAL TANKS CONSUMPTION REPORT -->

            <h5
              style="font-size: 1.1rem; margin-bottom: -5px; padding-left: 10px"
            >
              {{
                hasTankStockPms ||
                hasTankStockAgo ||
                hasTankStockDpk ||
                hasTankStockLpg
                  ? $t("text.cDashboard.productInventory")
                  : " "
              }}
            </h5>
            <div class="row mb-2 pos_trans_card_holder" v-if="!showLoader">
              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount]"
                v-if="hasTankStockPms"
              >
                <!-- <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount, LGgridNum, MDgridNum]"
                v-if="hasTankStockPms"
              > -->
                <div
                  class="card_container_1 pos-card mt-3 card-vertical-center"
                >
                  <h4 class="stations_card_header">
                    {{ countryProducts.products.product1 }}
                  </h4>
                  <div class="oil_drop_div_1">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h4 style="font-size: 1.3rem">
                      {{ convertThousand(pmsTankStock.volume) }}Ltrs
                    </h4>
                  </div>
                </div>
              </div>
              <!-- NO PMS N/A -->
              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="productCount"
                v-if="!hasTankStockPms"
              >
                <div
                  class="card_container_greyed pos-card mt-3 card-vertical-center"
                >
                  <h5 class="stations_card_header disabled-text">PMS</h5>
                  <div class="oil_drop_div_1 disabled-label-bg">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h5 class="">N/A</h5>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount]"
                v-if="hasTankStockAgo"
              >
                <!-- <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount, LGgridNum, MDgridNum]"
                v-if="hasTankStockAgo"
              > -->
                <div
                  class="card_container_1 pos-card mt-3 card-vertical-center"
                >
                  <h5 class="stations_card_header_1">
                    {{ countryProducts.products.product2 }}
                  </h5>
                  <div class="oil_drop_div_2">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h4 style="font-size: 1.3rem">
                      {{ convertThousand(agoTankStock.volume) }}Ltrs
                    </h4>
                  </div>
                </div>
              </div>
              <!-- NO AGO N/A -->
              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="productCount"
                v-if="!hasTankStockAgo"
              >
                <div
                  class="card_container_greyed pos-card mt-3 card-vertical-center"
                >
                  <h5 class="stations_card_header disabled-text">AGO</h5>
                  <div class="oil_drop_div_1 disabled-label-bg">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h5 class="">N/A</h5>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount]"
                v-if="hasTankStockDpk"
              >
                <!-- <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount, LGgridNum, MDgridNum]"
                v-if="hasTankStockDpk"
              > -->
                <div
                  class="card_container_1 pos-card mt-3 card-vertical-center"
                >
                  <h4 class="stations_card_header_2">
                    {{ countryProducts.products.product3 }}
                  </h4>
                  <div class="oil_drop_div_3">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h4 style="font-size: 1.3rem">
                      {{ convertThousand(dpkTankStock.volume) }}Ltrs
                    </h4>
                  </div>
                </div>
              </div>

              <!-- NO DPK N/A -->
              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="productCount"
                v-if="!hasTankStockDpk"
              >
                <div
                  class="card_container_greyed pos-card mt-3 card-vertical-center"
                >
                  <h5 class="stations_card_header disabled-text">DPK</h5>
                  <div class="oil_drop_div_1 disabled-label-bg">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h5 class="">N/A</h5>
                  </div>
                </div>
              </div>

              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount]"
                v-if="hasTankStockLpg"
              >
                <!-- <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="[productCount, LGgridNum, MDgridNum]"
                v-if="hasTankStockLpg"
              > -->
                <div
                  class="card_container_1 pos-card mt-3 card-vertical-center"
                >
                  <h4 class="stations_card_header_1" style="color: purple">
                    {{ countryProducts.products.product4 }}
                  </h4>
                  <div class="oil_drop_div_4" style="background: purple">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h4 style="font-size: 1.3rem">
                      {{ convertThousand(lpgTankStock.volume) }}Ltrs
                    </h4>
                    <small class="dashboard__card__header_bottom"> </small>
                  </div>
                </div>
              </div>

              <!-- NO LPG N/A -->
              <div
                class="col-lg-3 col-md-3 remove_padding-right pos_trans_card"
                :class="productCount"
                v-if="!hasTankStockLpg"
              >
                <div
                  class="card_container_greyed pos-card mt-3 card-vertical-center"
                >
                  <h5 class="stations_card_header disabled-text">LPG</h5>
                  <div class="oil_drop_div_1 disabled-label-bg">
                    <div class="text-center">
                      <img src="@/assets/img/drop-of-liquid.png" width="50%" />
                    </div>
                  </div>
                  <div class="mt-3 text-center">
                    <h5 class="">N/A</h5>
                  </div>
                </div>
              </div>
            </div>

            <!-- REVENUE AND PAYMENT CHANNEL TABLE -->
            <div
              class="section_3_table_section mt-3"
              style="
                border: 3px solid #ae91d3;
                border-radius: 10px;
                background-color: #fcfcfc;
                min-height: 480px !important;
                height: 490px !important;
                overflow: auto;
                scrollbar-width: none;
                -ms-overflow-style: none;
              "
            >
              <div class="row">
                <div class="ml-2">
                  <ul class="tabs__lists d-flex justify-content-center">
                    <li class="ml-1" @click="changeTab('pchannel')">
                      <a
                        href="#0"
                        class="tab_link"
                        :class="[
                          tab === 'pchannel' ? 'active__tab__link' : null,
                        ]"
                        :style="[
                          tab === 'pchannel' ? { color: '#4C2E73' } : null,
                        ]"
                      >
                        {{ $t("text.omit.paymentChannel") }}
                      </a>
                    </li>

                    <li class="ml-3" @click="changeTab('revenue')">
                      <a
                        href="#0"
                        class="tab_link"
                        :class="[
                          tab === 'revenue' ? 'active__tab__link' : null,
                        ]"
                        :style="[
                          tab === 'revenue' ? { color: '#4C2E73' } : null,
                        ]"
                      >
                        {{ $t("text.omit.revenue") }}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <!-- NEW TABLE -->
              <div v-show="tab === 'pchannel'">
                <table class="table table-hover">
                  <tbody>
                    <tr
                      @click="openRouteInNewTab('branch_POS')"
                      style="cursor: pointer"
                    >
                      <td class="pl-4 text-uppercase d-flex">
                        <span>
                          <img
                            src="@/assets/img/dpossales.png"
                            width="20px"
                            class="mr-2"
                          />
                        </span>
                        {{ $t("text.sales.posSales") }}
                      </td>
                      <td class="text-right pr-4">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT"
                        ></pulse-loader>
                        <span v-else> {{ pccurrency }}{{ pcposSales }} </span>
                      </td>
                    </tr>
                    <tr
                      @click="openRouteInNewTab('BranchRetainershipSales')"
                      style="cursor: pointer"
                    >
                      <td class="pl-4 text-uppercase d-flex">
                        <span>
                          <img
                            src="@/assets/img/desales.png"
                            width="20px"
                            class="mr-2"
                          />
                        </span>
                        <!-- {{ $t("text.cMasterLayout.retainership") }} -->
                        {{ $t("text.sales.retainerSales") }}
                      </td>
                      <td class="text-right pr-4">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT"
                        ></pulse-loader>
                        <span v-else>
                          {{ pccurrency }}{{ pcretainership }}
                        </span>
                      </td>
                    </tr>
                    <tr
                      @click="openRouteInNewTab('branch_wallet')"
                      style="cursor: pointer"
                    >
                      <td class="pl-4 text-uppercase d-flex">
                        <span>
                          <img
                            src="@/assets/img/desales.png"
                            width="20px"
                            class="mr-2"
                          />
                        </span>
                        {{ $t("text.omit.remisSales") }}
                      </td>
                      <td class="text-right pr-4">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT"
                        ></pulse-loader>
                        <span v-else> {{ pccurrency }}{{ pcesales }} </span>
                      </td>
                    </tr>
                    <tr
                      @click="openRouteInNewTab('branch_cash_flow')"
                      style="cursor: pointer"
                    >
                      <td class="pl-4 text-uppercase d-flex">
                        <span>
                          <img
                            src="@/assets/img/dcash.png"
                            width="20px"
                            class="mr-2"
                          />
                        </span>
                        {{ $t("text.bExpenses.cash") }}
                      </td>
                      <td class="text-right pr-4">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT"
                        ></pulse-loader>
                        <span v-else> {{ pccurrency }}{{ pccash }} </span>
                      </td>
                    </tr>
                    <tr
                      @click="showBank = !showBank"
                      style="cursor: pointer"
                      @mouseenter="hoverWT = true"
                      @mouseleave="hoverWT = false"
                      :style="[hoverWT ? { backgroundColor: '#e9ecef' } : null]"
                    >
                      <td class="pl-4 text-uppercase d-flex">
                        <span>
                          <img
                            src="@/assets/img/dbankdep.png"
                            width="20px"
                            class="mr-2"
                          />
                        </span>
                        {{ $t("text.bMasterLayout.bankDeposits") }}
                      </td>
                      <td class="text-right pr-4">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT"
                        ></pulse-loader>
                        <span v-else>
                          {{ pccurrency }}{{ pcbankDeposit }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- TABLE UNDER BANK DEPOSIT -->
                <transition name="slide-down" appear>
                  <div
                    @click="openRouteInNewTab('branch_bank_deposits')"
                    @mouseenter="hoverWT = true"
                    @mouseleave="hoverWT = false"
                    v-if="showBank"
                    class="row m-auto text-uppercase"
                    :style="[hoverWT ? { backgroundColor: '#e9ecef' } : null]"
                    style="
                      color: #667084;
                      font-size: 12px;
                      margin-top: -20px !important;
                      cursor: pointer;
                    "
                  >
                    <div class="col-2 d-flex justify-content-end">
                      <img
                        src="@/assets/img/dtablines.png"
                        width="10px"
                        height="100px"
                        class="mr-2 ml-2"
                      />
                    </div>
                    <div class="col-10 mt-3">
                      <div class="d-flex justify-content-between">
                        <div>
                          <p>{{ $t("text.omit.payDirect") }}:</p>
                        </div>
                        <hr
                          class="mt-2"
                          style="
                            border-bottom: 2px dashed #c8ccd3;
                            max-width: 250px;
                            min-width: 40px;
                          "
                        />
                        <div class="mr-2">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT2"
                          ></pulse-loader>
                          <p v-else>
                            {{ pccurrency }}{{ pcpayDirectBankDeposit }}
                          </p>
                        </div>
                      </div>
                      <div class="d-flex justify-content-between">
                        <div>
                          <p>{{ $t("text.omit.directTransfer") }}:</p>
                        </div>
                        <hr
                          class="mt-2"
                          style="
                            border-bottom: 2px dashed #c8ccd3;
                            max-width: 250px;
                            min-width: 40px;
                          "
                        />
                        <div class="mr-2">
                          <pulse-loader
                            size="15px"
                            v-if="loadingNT2"
                          ></pulse-loader>
                          <p v-else>
                            {{ pccurrency }}{{ pcdirectBankDeposit }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </transition>

                <P class="text-left"
                  ><span class="text-danger">**</span
                  ><span v-if="generalDateRange.start !== generalDateRange.end">
                    {{ $t("text.sales.outstandingCash") }}
                    {{ $t("text.calendar.from") }} ({{
                      $moment(generalDateRange.start, "DD-MM-YYYY").format(
                        "MMMM D, YYYY"
                      )
                    }}
                    -
                    {{
                      $moment(generalDateRange.end, "DD-MM-YYYY").format(
                        "MMMM D, YYYY"
                      )
                    }}) {{ $t("text.omit.is") }}</span
                  >
                  <span v-else>
                    {{ $t("text.sales.outstandingCash") }}
                    {{ $t("text.for.text") }} ({{
                      $moment(generalDateRange.start, "DD-MM-YYYY").format(
                        "MMMM D, YYYY"
                      )
                    }}) {{ $t("text.omit.is") }}</span
                  >
                  <pulse-loader
                    style="display: inline"
                    size="15px"
                    v-if="loadingNT"
                  ></pulse-loader>
                  <span v-else class="font-weight-bold"
                    >{{ pccurrency }}{{ pcoutstandingCash }}</span
                  ></P
                >
              </div>
              <div v-show="tab === 'revenue'">
                <table class="table table-hover">
                  <tbody>
                    <tr
                      @click="openRouteInNewTab('NonWetProductsBranchSales')"
                      style="cursor: pointer"
                    >
                      <td class="pl-4 text-uppercase d-flex">
                        <span>
                          <img
                            src="@/assets/img/dstock.png"
                            width="20px"
                            class="mr-2"
                          />
                        </span>
                        {{ $t("text.cusMasterLayout.dryStock") }}
                      </td>
                      <td class="text-right pr-4">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT2"
                        ></pulse-loader>
                        <span v-else>
                          {{ pccurrency2 }}{{ convertThousand(pcdryStock) }}
                        </span>
                      </td>
                    </tr>
                    <tr
                      class=""
                      @mouseenter="hoverWT = true"
                      @mouseleave="hoverWT = false"
                      :style="[hoverWT ? { backgroundColor: '#e9ecef' } : null]"
                    >
                      <td class="pl-4 text-uppercase d-flex">
                        <span>
                          <img
                            src="@/assets/img/dstock.png"
                            width="20px"
                            class="mr-2"
                          />
                        </span>
                        {{ $t("text.omit.wetStock") }}
                        <!-- <span class="ml-3" style="cursor: pointer">
                            <i class="fa fa-angle-down sidenav_arrow"></i>
                          </span> -->
                      </td>
                      <td class="text-right pr-4">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT2"
                        ></pulse-loader>
                        <span v-else>
                          {{ pccurrency2 }}{{ convertThousand(pcwetStock) }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>

                <!-- TABLE UNDER WET STOCK -->
                <div
                  @mouseenter="hoverWT = true"
                  @mouseleave="hoverWT = false"
                  class="row m-auto text-uppercase"
                  :style="[hoverWT ? { backgroundColor: '#e9ecef' } : null]"
                  style="
                    color: #667084;
                    font-size: 12px;
                    margin-top: -20px !important;
                  "
                >
                  <div class="col-2 d-flex justify-content-end">
                    <img
                      src="@/assets/img/dtablines.png"
                      width="10px"
                      height="100px"
                      class="mr-2 ml-2"
                    />
                  </div>
                  <div class="col-10 mt-3">
                    <div class="d-flex justify-content-between">
                      <div>
                        <p>{{ $t("text.omit.dispensed") }}:</p>
                      </div>
                      <hr
                        class="mt-2"
                        style="
                          border-bottom: 2px dashed #c8ccd3;
                          max-width: 250px;
                          min-width: 40px;
                        "
                      />
                      <div class="mr-2">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT2"
                        ></pulse-loader>
                        <p v-else>
                          {{ pccurrency2 }}{{ convertThousand(pcbalance) }}
                        </p>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <div>
                        <p>{{ $t("text.omit.rtt") }}:</p>
                      </div>
                      <hr
                        class="mt-2"
                        style="
                          border-bottom: 2px dashed #c8ccd3;
                          max-width: 250px;
                          min-width: 40px;
                        "
                      />
                      <div class="mr-2">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT2"
                        ></pulse-loader>
                        <p v-else>
                          {{ pccurrency2 }}{{ convertThousand(pcrtt) }}
                        </p>
                      </div>
                    </div>
                    <div class="d-flex justify-content-between">
                      <div>
                        <p>{{ $t("text.cMasterLayout.sales") }}:</p>
                      </div>
                      <hr
                        class="mt-2"
                        style="
                          border-bottom: 2px dashed #c8ccd3;
                          max-width: 250px;
                          min-width: 40px;
                        "
                      />
                      <div class="mr-2">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT2"
                        ></pulse-loader>
                        <p v-else>
                          {{ pccurrency2
                          }}{{ convertThousand(pcbalance - pcrtt) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <table class="table table-hover">
                  <tbody>
                    <tr
                      @click="openRouteInNewTab('expenses')"
                      style="cursor: pointer"
                    >
                      <td class="pl-4 text-uppercase d-flex">
                        <span>
                          <img
                            src="@/assets/img/dexpenses.png"
                            width="20px"
                            class="mr-2"
                          />
                        </span>
                        {{ $t("text.cMasterLayout.expenses") }}
                      </td>
                      <td class="text-right pr-4">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT2"
                        ></pulse-loader>
                        <span v-else>
                          {{ pccurrency2 }}{{ convertThousand(pcexpenses) }}
                        </span>
                      </td>
                    </tr>
                    <tr class="font-weight-bold">
                      <td class="pl-4 text-uppercase d-flex">
                        <span>
                          <img
                            src="@/assets/img/dcash.png"
                            width="20px"
                            class="mr-2"
                          />
                        </span>
                        {{ $t("text.balance.title") }}
                      </td>
                      <td class="text-right pr-4">
                        <pulse-loader
                          size="15px"
                          v-if="loadingNT2"
                        ></pulse-loader>
                        <span v-else style="color: #4c2e73">
                          {{ pccurrency2
                          }}{{
                            convertThousand(
                              pcdryStock + pcwetStock - pcexpenses
                            )
                          }}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- SALES VS TARGET -->
          <div
            class="col-lg-5 col-sm-12 drivers_block spread dashboard_left"
            style="height: 100%"
          >
            <h5
              class="mb-2 ml-4 mobMarg"
              style="font-size: 1.1rem; margin-top: -30px"
            >
              {{ $t("text.bDashboard.salesVTarget") }}
            </h5>
            <div class="remove_padding mobile_tiles" style="">
              <div
                class="text-center col-md-12 col-sm-12 text_div_block lnk padding_right_desk"
              >
                <div class="py-4 section_3_right_column_block new_tiles">
                  <div class="">
                    <div class="row">
                      <div class="col-lg-5"></div>
                      <div class="col-lg-7">
                        <vue-ctk-date-time-picker
                          id="first_date_picker"
                          v-model="dateRange1"
                          :max-date="maxDate"
                          :onlyDate="true"
                          :autoClose="true"
                          :locale="this.$root.$i18n.locale"
                          :color="$store.getters.getDatePickerColor"
                          format="DDMMYYYY"
                          formatted="DD/MM/YYYY"
                          :label="$t('text.calendar.selectDate')"
                        />
                      </div>
                    </div>

                    <div class="highcharts__div">
                      <highcharts
                        :options="NewSalesTarget"
                        class=""
                      ></highcharts>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row remove_padding mobile_tiles"
              style="margin-top: 220px; width: 98%"
            >
              <div
                class="pl-3 text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_right_desk"
              >
                <router-link
                  :to="{
                    name: 'tanks',
                    query: this.$route.query.branchId
                      ? {
                          branchId: this.$route.query.branchId,
                          companyId: $route.query.companyId,
                          dealerId: this.$route.query.dealerId,
                          groupId: this.$route.query.groupId,
                          regionId: this.$route.query.regionId,
                        }
                      : null,
                  }"
                  class="router_link__text"
                >
                  <div
                    class="py-4 section_3_right_column_block new_tiles"
                    style="height: 100%"
                  >
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.bDashboard.tanksInStation") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ tanksCount }}
                      </h3>
                    </div>
                  </div>
                </router-link>
              </div>

              <div
                class="text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_left_desk"
              >
                <router-link
                  :to="{
                    name: 'pumps',
                    query: this.$route.query.branchId
                      ? {
                          branchId: this.$route.query.branchId,
                          companyId: $route.query.companyId,
                          dealerId: this.$route.query.dealerId,
                          groupId: this.$route.query.groupId,
                          regionId: this.$route.query.regionId,
                        }
                      : null,
                  }"
                  class="router_link__text"
                >
                  <div
                    class="py-4 section_3_right_column_block new_tiles"
                    style="height: 100%"
                  >
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.bDashboard.pumpsInStation") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ pumpsCount }}
                      </h3>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>

            <div
              class="row remove_padding mobile_tiles mt-3"
              style="width: 98%"
            >
              <div
                class="pl-3 text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_right_desk"
              >
                <router-link
                  :to="{
                    name: 'branch_tanks_filled',
                    query: this.$route.query.branchId
                      ? {
                          branchId: this.$route.query.branchId,
                          companyId: $route.query.companyId,
                          dealerId: this.$route.query.dealerId,
                          groupId: this.$route.query.groupId,
                          regionId: this.$route.query.regionId,
                        }
                      : null,
                  }"
                  class="router_link__text"
                >
                  <div class="py-4 section_3_right_column_block new_tiles">
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.bDashboard.tanksFilled") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="stations__block_text_1 mobile_font"
                        style="font-size: 40px"
                      >
                        {{ tanksFilled }}
                      </h3>
                    </div>
                  </div>
                </router-link>
              </div>

              <div
                class="text-center col-md-6 col-sm-12 text_div_block lnk mobile_under_tile padding_left_desk"
              >
                <div
                  class="py-4 section_3_right_column_block new_tiles"
                  style="height: 100%"
                >
                  <div class="">
                    <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                      {{ $t("text.bDashboard.dailyTcount") }}
                    </h3>

                    <!-- <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                      {{ $t("text.bDashboard.pmsAgo") }} /
                      {{ $t("text.cDashboard.lpg") }}
                    </h3> -->
                    <h3
                      class="stations__block_text_1 mobile_font mt-4"
                      style="font-size: 20px"
                    >
                      <span style="color: #d8991c">{{
                        PMSTransactionCount
                      }}</span>
                      /
                      <span style="color: #6cc066">{{
                        AGOTransactionCount
                      }}</span>
                      /
                      <span style="color: #1864ab">{{
                        DPKTransactionCount
                      }}</span>
                      /
                      <span style="color: #820080">{{
                        LPGTransactionCount
                      }}</span>
                    </h3>
                  </div>
                  <!-- <div class="">
                    <h3
                      class="stations__block_text_1 mobile_font"
                      style="font-size: 20px"
                    >
                      {{ PMSTransactionCount }} / {{ AGOTransactionCount }} /
                      {{ LPGTransactionCount }}
                    </h3>
                  </div> -->
                </div>
              </div>
            </div>

            <!-- <div
              class="row remove_padding mobile_tiles"
              style="margin-top: 33px; width: 98%"
            >
              <div
                class="text-center col-md-12 col-sm-12 text_div_block lnk mobile_under_tile padding_right_desk"
              >
                <router-link
                  :to="{
                    name: 'branch_tanks_filled',
                    query: this.$route.query.branchId
                      ? {
                          branchId: this.$route.query.branchId,
                          companyId: $route.query.companyId,
                          dealerId: this.$route.query.dealerId,
                          groupId: this.$route.query.groupId,
                          regionId: this.$route.query.regionId,
                        }
                      : null,
                  }"
                  class="router_link__text"
                >
                  <div class="py-4 section_3_right_column_block new_tiles">
                    <div class="">
                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.bDashboard.dailyTcount") }}
                      </h3>

                      <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                        {{ $t("text.bDashboard.pmsAgo") }} /
                        {{ $t("text.cDashboard.lpg") }}
                      </h3>
                    </div>
                    <div class="">
                      <h3
                        class="my-4 stations__block_text_1 mobile_font"
                        style="font-size: 45px"
                      >
                        {{ PMSTransactionCount }} / {{ AGOTransactionCount }} /
                        {{ LPGTransactionCount }}
                      </h3>
                    </div>
                  </div>
                </router-link>
              </div>
            </div> -->

            <!-- <div
              class="row remove_padding mobile_under_tile tile_padding_top daily_count mt-3"
              style="margin-bottom: 0px"
            >
              <div class="text-center col-md-12 text_div_block lnk">
                <div
                  class="py-4 section_3_right_column_block"
                  style="height: 82%"
                >
                  <div class="">
                    <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                      {{ $t("text.bDashboard.dailyTcount") }}
                    </h3>

                    <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                      {{ $t("text.bDashboard.pmsAgo") }} /
                      {{ $t("text.cDashboard.lpg") }}
                    </h3>
                  </div>
                  <div class="">
                    <h3
                      class="my-4 stations__block_text_1 mobile_font"
                      style="font-size: 45px"
                    >
                      {{ PMSTransactionCount }} / {{ AGOTransactionCount }} /
                      {{ LPGTransactionCount }}
                    </h3>
                  </div>
                </div>
              </div>
            </div> -->

            <!-- ESITIMATED PUMP CALIBRATION (TO BE ADDED) -->
            <!-- <div
							class="row remove_padding mobile_under_tile tile_padding_top"
							style="margin-top: -55px"
						>
							<div class="text-center col-md-12 text_div_block lnk">
								<router-link
									:to="{
										name:
											calibrationType === 'array' ? 'pumps_calibration' : null,
										query: this.$route.query.branchId
											? {
													branchId: this.$route.query.branchId,
													companyId: $route.query.companyId,
                          dealerId: this.$route.query.dealerId,
                          groupId: this.$route.query.groupId,
                          regionId: this.$route.query.regionId,
											  }
											: null,
									}"
									class="router_link__text"
									:class="
										calibrationType === 'number' ? 'disabledCursor' : null
									"
								>
									<div
										class="py-4 section_3_right_column_block"
										style="height: 90%; margin-top: 20px"
									>
										<div class="">
											<h3 class="mt-1 stations__block_text_1 mobile_title_font">
												{{ $t("text.bDashboard.estimatedPumpsCalibration") }}
											</h3>
											<div class="">
												<h3
													class="mt-4 stations__block_text_1 mobile_font"
													style="font-size: 40px"
													:class="
														calibrationType === 'number'
															? 'disabledColor'
															: null
													"
												>
													{{ averagePumpsCalibrationRatio }}
												</h3>
											</div>
										</div>
									</div>
								</router-link>
							</div>
						</div> -->
          </div>
        </div>

        <div class="mt-3 row mobile_marg_ri">
          <div class="col-lg-3 col-sm-12 padding_right_desk">
            <router-link
              :to="{
                name: 'pump_fault',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="router_link__text"
            >
              <div
                class="py-3 section_3_right_column_block mobile_dis_height"
                style="height: 135px; text-align: center"
              >
                <div class="">
                  <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                    {{ $t("text.bDashboard.pumpsFault") }}
                  </h3>
                </div>
                <div class="">
                  <h3
                    class="mt-4 stations__block_text_1 mobile_font"
                    style="font-size: 40px"
                  >
                    {{ pumpsFault }}
                  </h3>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-3 col-sm-12 padding_left_desk padding_right_desk">
            <router-link
              :to="{
                name: 'branch_disconnected_pumps',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="router_link__text"
            >
              <div
                class="py-3 section_3_right_column_block mobile_dis_height"
                style="height: 135px; text-align: center"
              >
                <div class="">
                  <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                    {{ $t("text.bDashboard.disconnectedPumps") }}
                  </h3>
                </div>
                <div class="">
                  <h3
                    class="mt-4 stations__block_text_1 mobile_font"
                    style="font-size: 40px"
                  >
                    {{ offlinePumps }}
                  </h3>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-3 col-sm-12 padding_left_desk">
            <router-link
              :to="{
                name: 'branch_offline_pumps',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="router_link__text"
            >
              <div
                class="py-3 section_3_right_column_block mobile_dis_height"
                style="height: 135px; text-align: center"
              >
                <div class="">
                  <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                    {{ $t("text.bDashboard.offlinePumps") }}
                  </h3>
                </div>
                <div class="">
                  <h3
                    class="mt-4 stations__block_text_1 mobile_font"
                    style="font-size: 40px"
                  >
                    {{ deviceNotPushing }}
                  </h3>
                </div>
              </div>
            </router-link>
          </div>

          <div class="col-lg-3 col-sm-12 padding_left_desk">
            <!-- <router-link
              :to="{
                name: 'branch_offline_pumps',
                query: this.$route.query.branchId
                  ? {
                      branchId: this.$route.query.branchId,
                      companyId: $route.query.companyId,
                      dealerId: this.$route.query.dealerId,
                      groupId: this.$route.query.groupId,
                      regionId: this.$route.query.regionId,
                    }
                  : null,
              }"
              class="router_link__text"
            > -->
            <div
              class="py-3 section_3_right_column_block mobile_dis_height"
              style="height: 135px; text-align: center"
            >
              <div class="">
                <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                  {{ $t("text.omit.avgLtr") }}
                </h3>

                <!-- <h3 class="mt-1 stations__block_text_1 mobile_title_font">
                  {{ $t("text.bDashboard.pmsAgo") }} /
                  {{ $t("text.cDashboard.dpk") }} /
                  {{ $t("text.cDashboard.lpg") }}
                </h3> -->
                <h3
                  class="stations__block_text_1 mobile_font mt-4"
                  style="font-size: 22px"
                >
                  <span style="color: #d8991c">{{ PMSAvgLtrCount }}</span> /
                  <span style="color: #6cc066">{{ AGOAvgLtrCount }}</span> /
                  <span style="color: #1864ab">{{ DPKAvgLtrCount }}</span> /
                  <span style="color: #820080">{{ LPGAvgLtrCount }}</span>
                </h3>
              </div>
              <!-- <div class="">
                <h3
                  class="stations__block_text_1 mobile_font"
                  style="font-size: 20px"
                >
                  <span style="color: #d8991c">{{ PMSAvgLtrCount }}</span> /
                  <span style="color: #6cc066">{{ AGOAvgLtrCount }}</span> /
                  <span style="color: #1864ab">{{ DPKAvgLtrCount }}</span> /
                  <span style="color: #820080">{{ LPGAvgLtrCount }}</span>
                </h3>
              </div> -->
            </div>
            <!-- </router-link> -->
          </div>
        </div>
      </section>
      <!-- NEW DASHBOARD ENDS HERE -->

      <div class="mt-3 section-2">
        <section
          v-show="userDetails.email !== 'supportest@gmail.com'"
          class="mt-3 section_3 last__ten__transactions__row"
        >
          <div class="row mobile_marg_ri">
            <div class="col-md-5 col-lg-8 table_block">
              <div
                class="highcharts__row"
                style="min-height: 400px; margin-right: 20px !important"
              >
                <div
                  class="col-md-12 section___column_2"
                  style="background-color: white"
                >
                  <div class="align-items-center">
                    <div class="">
                      <div class="mt-2 mr-2 drop_down_section">
                        <div
                          class="align-items-center"
                          style="border-bottom: 1px solid grey"
                        >
                          <vue-ctk-date-time-picker
                            id="second_date_picker"
                            v-model="dateRange3"
                            :max-date="maxDate"
                            :onlyDate="true"
                            :autoClose="true"
                            :locale="this.$root.$i18n.locale"
                            :color="$store.getters.getDatePickerColor"
                            format="DDMMYYYY"
                            formatted="DD/MM/YYYY"
                            :label="$t('text.calendar.selectDate')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <highcharts
                  :options="hourlySalesSplineOptions"
                  class=""
                  v-if="!showHourlySalesLoader"
                ></highcharts>
                <pulse-loader
                  size="15px"
                  v-if="showHourlySalesLoader"
                  class="mt-5"
                ></pulse-loader>
              </div>
              <!-- <div class="section_3_table_section" >
                
              </div> -->
            </div>
            <div class="col-lg-4 col-md-4 drivers_block">
              <div
                class="highcharts__div"
                style="background: white; min-height: 400px"
              >
                <apexchart
                  type="donut"
                  :options="chartOptions"
                  :series="donutSeries"
                ></apexchart>
              </div>
            </div>
          </div>
        </section>

        <section
          v-show="userDetails.email !== 'supportest@gmail.com'"
          class="mt-3 mb-4 section_3 last__ten__transactions__row"
        >
          <div class="row">
            <div class="col-md-5 col-lg-12 table_block">
              <div
                class="highcharts__row"
                style="min-height: 400px; padding-right: 20px !important"
              >
                <div
                  class="col-md-12 section___column_2"
                  style="background-color: white"
                >
                  <div class="align-items-center">
                    <div class="">
                      <div class="mt-2 mr-5 drop_down_section">
                        <div
                          class="align-items-center"
                          style="border-bottom: 1px solid grey"
                        >
                          <vue-ctk-date-time-picker
                            id="third_date_picker"
                            v-model="dateRange2"
                            :max-date="maxDate"
                            :onlyDate="true"
                            :autoClose="true"
                            :locale="this.$root.$i18n.locale"
                            :color="$store.getters.getDatePickerColor"
                            format="DDMMYYYY"
                            formatted="DD/MM/YYYY"
                            :label="$t('text.calendar.selectDate')"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <highcharts
                  :options="productStockHourlySplineOptions"
                  class=""
                  v-if="!productStockHourlySalesLoader"
                ></highcharts>
                <pulse-loader
                  size="15px"
                  v-if="productStockHourlySalesLoader"
                  class="mt-5"
                ></pulse-loader>
              </div>
            </div>
          </div>
        </section>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import configObject from "@/config";
import { VueApexCharts } from "apexcharts";
import { Chart } from "highcharts-vue";
import countryProducts from "@/products";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import StarRating from "vue-star-rating";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
export default {
  name: "DashboardHome",
  components: {
    MasterLayout,
    Highcharts: Chart,
    VueApexCharts,
    PulseLoader,
    StarRating,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  computed: {
    userInfo() {
      const user = localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null;

      if (user) {
        if (!user.roles) {
          if (user.role) {
            user.roles = user.role.split(",");
            localStorage.setItem("userDetails", JSON.stringify(user));
          }
        }
      }
      return user;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    sortInitialValues() {
      return (this.sortedValues = this.initialValues.sort((a, b) => b - a));
    },
    countryProducts: function () {
      return this.$store.getters.getCountryProducts;
    },
  },
  data() {
    return {
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      dateRange1: this.startDate,
      dateRange2: this.tankStartDate,
      dateRange3: this.hourlyTransactionsDate,
      pluginStartDate: this.$moment().subtract(0, "days").format("D-M-YYYY"),
      pluginEndDate: this.$moment().format("D-M-YYYY"),
      startDate: this.$moment().format("MMMM D, YYYY"),
      tankStartDate: this.$moment().format("MMMM D, YYYY"),
      hourlyTransactionsDate: this.$moment().format("MMMM D, YYYY"),
      generalStartDate: this.$moment()
        .subtract(0, "days")
        .format("MMMM D, YYYY"),
      generalEndDate: this.$moment().format("MMMM D, YYYY"),
      generalPluginStartDate: this.$moment()
        .subtract(0, "days")
        .format("D-M-YYYY"),
      generalPluginEndDate: this.$moment().format("D-M-YYYY"),
      generalDateRange: {
        start: this.pluginStartDate,
        end: this.pluginEndDate,
      },
      generalMaxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
      transactionCountStartDate: this.$moment()
        .subtract(1, "days")
        .format("MMMM D, YYYY"),
      transactionCountEndDate: this.$moment().format("MMMM D, YYYY"),
      showHourlySalesLoader: null,
      PMSTransactionCount: 0,
      AGOTransactionCount: 0,
      DPKTransactionCount: 0,
      LPGTransactionCount: 0,
      PMSAvgLtrCount: 0,
      AGOAvgLtrCount: 0,
      DPKAvgLtrCount: 0,
      LPGAvgLtrCount: 0,
      LGgridNum: "",
      MDgridNum: "",
      userDetails: localStorage.getItem("userDetails")
        ? JSON.parse(localStorage.getItem("userDetails"))
        : null,
      productStockHourlySalesLoader: false,
      getting: true,
      branchRating: "",
      branch: {},
      branchId: null,
      showTank: true,
      offlinePumps: 0,
      deviceNotPushing: 0,
      pumpsFault: 0,
      availableProducts: [],
      calibrationType: "number",
      pageSettings: {
        pageSizes: [10, 20, 50, 100, 200],
        pageCount: 4,
        pageSize: 10,
      },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      agoRateColor: "",
      lpgRateColor: "",
      pmsRateColor: "",
      interval: null,
      dpkRateColor: "",
      totalRateColor: "",
      tanksFilled: 0,
      pumpsCount: 0,
      hasTankStockLpg: false,
      hasTankStockPms: false,
      hasTankStockAgo: false,
      hasTankStockDpk: false,
      hasLpg: false,
      hasPms: false,
      hasAgo: false,
      hasDpk: false,
      loadedFirst: false,
      tanksCount: 0,
      pumpsAverageTimePerLiterCount: 0,
      averagePumpsCalibrationRatio: 0,
      agoUp: true,
      productCount: "col-lg-3",
      prodCounts: 0,
      salesTargetCount: "col-lg-4",
      dpkUp: true,
      pmsUp: true,
      totalUp: true,
      lpgUp: true,
      colVar: 3,
      pmsRate: 0,
      agoRate: 0,
      dpkRate: 0,
      lpgRate: 0,
      totalRate: 0,
      values: [230, 308, 520, 130, 200],
      showLoader: true,
      showAll: false,
      tanks: [],
      pumpsCalibration: [],
      productSummary: [],
      lpgSummary: { volume: 0, amount: 0 },
      pmsSummary: { volume: 0, amount: 0 },
      agoSummary: { volume: 0, amount: 0 },
      dpkSummary: { volume: 0, amount: 0 },
      pmsTankStock: { volume: 0, amount: 0 },
      agoTankStock: { volume: 0, amount: 0 },
      dpkTankStock: { volume: 0, amount: 0 },
      lpgTankStock: { volume: 0, amount: 0 },
      isPartner: false,

      pmsCond: false,
      agoCond: false,
      dpkCond: false,
      lpgCond: false,
      tab: "pchannel",

      hoverWT: false,
      showBank: false,
      pcbankDeposit: 0,
      pcdirectBankDeposit: 0,
      pcpayDirectBankDeposit: 0,
      pccash: 0,
      pccurrency: "",
      pcesales: 0,
      pcretainership: 0,
      pcoutstandingCash: 0,
      pcposSales: 0,
      pcbalance: 0,
      pcdryStock: 0,
      pcexpenses: 0,
      pcwetStock: 0,
      pcrtt: 0,
      pccurrency2: "",
      loadingNT: true,
      loadingNT2: true,

      NewSalesTarget: {
        chart: {
          height: "50%",
          type: "bar",
        },
        title: {
          text: undefined,
        },

        xAxis: {
          type: "category",
        },
        yAxis: {
          title: {
            text: undefined,
          },
        },
        legend: {
          enabled: false,
        },
        plotOptions: {
          series: {
            maxPointWidth: 30,
            groupPadding: 0,
            borderWidth: 0,
            dataLabels: {
              enabled: true,
              format: "{point.y:.1f}%",
            },
          },
        },

        tooltip: {
          headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
          pointFormat:
            '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.2f}%</b><br/>',
        },

        series: [],
      },

      pmsGuageOptions: {
        chart: {
          type: "solidgauge",
          height: "65%",
        },
        title: {
          text: "",
          style: {
            fontSize: "12px",
            color: "#d8991c",
          },
        },
        tooltip: {
          enabled: false,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
          style: {
            fontSize: "12px",
          },
          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for Move
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: "rgb(254,228,179)",
              borderWidth: 0,
            },
          ],
        },
        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: true,
              y: -50,
              borderWidth: 0,
              backgroundColor: "none",
              useHTML: true,
              shadow: false,
              style: {
                fontSize: "16px",
              },
              pointFormat:
                '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',
              positioner: function (labelWidth) {
                return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: this.chart.plotHeight / 2 + 15,
                };
              },
            },
          },
          linecap: "round",
          stickyTracking: false,
          rounded: false,
        },
        series: [
          {
            name: "",
            data: [
              {
                color: "#d8991c",
                radius: "112%",
                innerRadius: "88%",
                y: 0,
                states: {
                  hover: {
                    enabled: false,
                  },
                },
              },
            ],
          },
        ],
      },
      agoGuageOptions: {
        chart: {
          type: "solidgauge",
          height: "65%",
        },
        title: {
          text: "",
          style: {
            fontSize: "12px",
            color: "#0fce29",
          },
        },
        tooltip: {
          enabled: false,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
          style: {
            fontSize: "12px",
          },
          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
          states: {
            hover: {
              enabled: false,
            },
          },
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for Move
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: "rgb(231, 255, 200)",
              opacity: 0.3,
              borderWidth: 0,
            },
          ],
        },
        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: true,
              y: -50,
              borderWidth: 0,
              backgroundColor: "none",
              useHTML: true,
              shadow: false,
              style: {
                fontSize: "16px",
              },
              pointFormat:
                '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',
              positioner: function (labelWidth) {
                return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: this.chart.plotHeight / 2 + 15,
                };
              },
            },
            linecap: "round",
            stickyTracking: false,
            rounded: false,
          },
        },
        series: [
          {
            name: "",
            data: [
              {
                color: "#0fce29",
                radius: "112%",
                innerRadius: "88%",
                y: 0,
              },
            ],
          },
        ],
      },
      dpkGuageOptions: {
        chart: {
          type: "solidgauge",
          height: "65%",
        },
        title: {
          text: "",
          style: {
            fontSize: "12px",
            color: "#00aced",
          },
        },
        tooltip: {
          enabled: false,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
          style: {
            fontSize: "12px",
          },
          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for Move
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: "rgb(207, 241, 254)",
              opacity: 0.3,
              borderWidth: 0,
            },
          ],
        },
        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: true,
              y: -50,
              borderWidth: 0,
              backgroundColor: "none",
              useHTML: true,
              shadow: false,
              style: {
                fontSize: "16px",
              },
              pointFormat:
                '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',
              positioner: function (labelWidth) {
                return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: this.chart.plotHeight / 2 + 15,
                };
              },
            },
            linecap: "round",
            stickyTracking: false,
            rounded: false,
          },
        },
        series: [
          {
            name: "",
            data: [
              {
                color: "#00aced",
                radius: "112%",
                innerRadius: "88%",
                y: 0,
              },
            ],
          },
        ],
      },
      lpgGuageOptions: {
        chart: {
          type: "solidgauge",
          height: "65%",
        },
        title: {
          text: "",
          style: {
            fontSize: "12px",
            color: "rgb(233, 141, 233)",
          },
        },
        tooltip: {
          enabled: false,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
          style: {
            fontSize: "12px",
          },
          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for Move
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: "rgb(233, 141, 233)",
              opacity: 0.3,
              borderWidth: 0,
            },
          ],
        },
        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: true,
              y: -50,
              borderWidth: 0,
              backgroundColor: "none",
              useHTML: true,
              shadow: false,
              style: {
                fontSize: "16px",
              },
              pointFormat:
                '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',
              positioner: function (labelWidth) {
                return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: this.chart.plotHeight / 2 + 15,
                };
              },
            },
            linecap: "round",
            stickyTracking: false,
            rounded: false,
          },
        },
        series: [
          {
            name: "",
            data: [
              {
                color: "purple",
                radius: "112%",
                innerRadius: "88%",
                y: 0,
              },
            ],
          },
        ],
      },
      greyedGuageOptions: {
        chart: {
          type: "solidgauge",
          height: "85%",
        },
        title: {
          text: "",
          style: {
            fontSize: "12px",
            color: "#f5f5f5",
          },
        },
        tooltip: {
          enabled: false,
          borderWidth: 0,
          backgroundColor: "none",
          shadow: false,
          style: {
            fontSize: "12px",
          },
          valueSuffix: "%",
          pointFormat:
            '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',
          positioner: function (labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15,
            };
          },
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [
            {
              // Track for Move
              outerRadius: "112%",
              innerRadius: "88%",
              backgroundColor: "#f5f5f5",
              opacity: 0.3,
              borderWidth: 0,
            },
          ],
        },
        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: [],
        },
        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: true,
              y: -50,
              borderWidth: 0,
              backgroundColor: "none",
              useHTML: true,
              shadow: false,
              style: {
                fontSize: "16px",
              },
              pointFormat:
                '{series.name}<br><span style="position: absolute; top: 50%; left: 50%; transform: translate(-45%, 45%); font-size:1.5em; color: {point.color}; font-weight: bold">{point.y}%</span>',
              positioner: function (labelWidth) {
                return {
                  x: (this.chart.chartWidth - labelWidth) / 2,
                  y: this.chart.plotHeight / 2 + 15,
                };
              },
            },
            linecap: "round",
            stickyTracking: false,
            rounded: false,
          },
        },
        series: [
          {
            name: "",
            data: [
              {
                color: "#f5f5f5",
                radius: "112%",
                innerRadius: "88%",
                // y: 0,
              },
            ],
          },
        ],
      },
      hourlySalesSplineOptions: {
        chart: {
          type: "areaspline",
        },
        title: {
          text: this.$t("text.bDashboard.hourlyTransactions"),
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: true,
            },
            pointPlacement: "on",
          },
        },
        series: [],
        legend: {
          enabled: true,
          layout: "horizontal",
          align: "left",
          verticalAlign: "bottom",
        },
        xAxis: {
          //lineColor: 'transparent',
          tickmarkPlacement: "on",
          labels: {
            enabled: true,
            // formatter: function() {
            //     var date = this.value;
            //     return this.$moment(date).format('h:mm A');
            // }
          },
          type: "datetime",
          startOnTick: true,
        },
        yAxis: {
          title: {
            text: "Volume (litres)",
          },
          //gridLineColor: 'transparent',
          labels: {
            enabled: true,
          },
        },
      },
      productStockHourlySplineOptions: {
        chart: {
          type: "areaspline",
        },
        title: {
          text: this.$t("text.bDashboard.tanksStock"),
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: true,
            },
            pointPlacement: "on",
          },
        },
        series: [],
        legend: {
          enabled: true,
          layout: "horizontal",
          align: "left",
          verticalAlign: "bottom",
        },
        xAxis: {
          //lineColor: 'transparent',
          tickmarkPlacement: "on",
          labels: {
            enabled: true,
            // formatter: function() {
            //     var date = this.value;
            //     return this.$moment(date).format('h:mm A');
            // }
          },
          type: "datetime",
          startOnTick: true,
        },
        yAxis: {
          title: {
            text: "Volume (litres)",
          },
          //gridLineColor: 'transparent',
          labels: {
            enabled: true,
          },
        },
      },
      donutSeries: [0, 0, 0],
      chartOptions: {
        chart: {
          type: "donut",
          height: "490px",
        },
        title: {
          text: this.$t("text.bDashboard.productGuage"),
          align: "center",
          margin: 30,
          offsetX: 0,
          offsetY: 0,
          floating: false,
          style: {
            fontSize: "18px",
            fontWeight: "400",
          },
        },
        // labels: [this.countryProducts.products.product2, this.countryProducts.products.product3, this.countryProducts.products.product1, this.countryProducts.products.product4],
        colors: ["#13cf2d", "#00aced", "#d8991c", "purple"],
        legend: {
          position: "bottom",
          onItemClick: {
            toggleDataSeries: true,
          },
          fontSize: "12px",
          fontWeight: 600,
          itemMargin: {
            horizontal: 15,
          },
        },
        responsive: [
          {
            options: {
              legend: {
                position: "bottom",
                onItemClick: {
                  toggleDataSeries: true,
                },
              },
            },
          },
        ],
      },
      pmsSplineOption: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
          categories: null,
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
      agoSplineOption: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
          categories: null,
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
      dpkSplineOption: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
          categories: null,
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
      lpgSplineOption: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
          categories: null,
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
      totalSplineOption: {
        chart: {
          type: "areaspline",
          height: "80px",
        },
        title: {
          text: "",
        },
        credits: {
          enabled: false,
        },
        plotOptions: {
          areaspline: {
            fillOpacity: 0.2,
          },
          series: {
            marker: {
              enabled: false,
            },
          },
        },
        series: null,
        legend: {
          enabled: false,
        },
        xAxis: {
          lineColor: "transparent",
          labels: {
            enabled: false,
          },
          categories: null,
        },
        yAxis: {
          title: {
            text: "",
          },
          gridLineColor: "transparent",
          labels: {
            enabled: false,
          },
        },
      },
    };
  },
  created() {
    this.$eventHub.$on("companyId", (companyId) => {
      this.$router.replace({
        query: {
          branchId: this.$route.query.branchId,
          dealerId: this.$route.query.dealerId,
          groupId: this.$route.query.groupId,
          regionId: this.$route.query.regionId,
          companyId,
        },
      });
    });
    document.title = `Retail Outlet Dashboard - Epump Retail Outlet`;
    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Retail Outlet Dashboard - ${branch.name}`;
    });
    this.dateRange1 = this.pluginStartDate;
    this.dateRange2 = this.pluginStartDate;
    this.dateRange3 = this.pluginStartDate;
    this.generalDateRange.start = this.generalPluginStartDate;
    this.generalDateRange.end = this.generalPluginEndDate;
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else {
      let token = JSON.parse(localStorage.getItem("userDetails")).token;
      if (token !== null) {
      } else {
        window.location.reload();
      }
    }
  },
  watch: {
    generalDateRange: function (newRange, oldRange) {
      // console.log("date changedd");
      if (newRange.start !== null && newRange.end !== null) {
        this.generalStartDate = this.$moment(
          newRange.start,
          "DD-MM-YYYY"
        ).format("MMMM D, YYYY");
        this.generalEndDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getPMSTransactionCount();
        this.getAvgLtrCount();
        this.getTankStock();
        this.getProductSummary();
        this.loadedFirst = false;
        this.getPaymentChannelsData();
        this.getRevenueData();
      }
    },

    branch: function (newBranch, oldBranch) {
      if (newBranch.id) {
        this.branchId = newBranch.id;
        this.getProductSummary();
        // this.fetchData();
        this.interval = setInterval(() => {
          this.getProductSummary();
          this.loadedFirst = true;
          this.getPaymentChannelsData();
          this.getRevenueData();
        }, 60000);
        if (this.$route.query.branchId) {
          this.branchId = this.branch.id;
          if (this.branchId !== null) {
            this.getProductSummary();
            this.showTank =
              this.branch.engagementLevel == "Full Auto" ? true : false;
            this.fetchData();
            this.interval = setInterval(() => {
              this.getProductSummary();
              this.loadedFirst = true;
              this.getPaymentChannelsData();
              this.getRevenueData();
            }, 60000);
            if (this.showTank) {
              this.getTanks();
              this.getTanksFilled();
              this.getTargetsParecentage();
            }
          }
        } else {
          if (this.branch.id) {
            this.branchId = this.branch.id;
          }
          if (this.branchId !== null) {
            this.showTank =
              this.branch.engagementLevel == "Full Auto" ? true : false;
            this.getHistoryChartsData();
            this.getDaySalesByHour();
            this.getTanksProbeByHour();
            this.getPumpCount();
            this.loadedFirst = false;
            this.getPaymentChannelsData();
            this.getRevenueData();
            // this.getPumpCalibration();
            if (
              this.userDetails.roles.includes("ManageOutlet") ||
              this.userDetails.roles.includes("Branch")
            ) {
              this.getTargetsParecentage();
            }
            this.getPumpsAverageTimePerLitre();
            this.getPumpsFault();
            this.getOfflinePmps();

            // fetchDatabranch;
            this.getDeviceNotPushing();
            this.getTankStock();
            this.getPMSTransactionCount();
            this.getAvgLtrCount();
            this.getTargetsParecentage();

            if (this.showTank) {
              this.getTanks();
              this.getTanksFilled();
            }
          }
        }
      }
    },
    dateRange1: function (newDate) {
      if (newDate && this.branchId) {
        this.startDate = this.$moment(newDate, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getTargetsParecentage();
      }
    },
    dateRange2: function (newDate) {
      if (newDate && this.branchId) {
        this.tankStartDate = this.$moment(newDate, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.getTanksProbeByHour();
      }
    },
    dateRange3: function (newDate) {
      if (newDate && this.branchId) {
        this.hourlyTransactionsDate = this.$moment(
          newDate,
          "DD-MM-YYYY"
        ).format("MMMM D, YYYY");
        this.getDaySalesByHour();
      }
    },
  },
  mounted() {
    if (this.userDetails.email == "demonstration@gmail.com") {
      this.$router.push({
        name: "manage_price",
        query: {
          branchId: this.$route.query.branchId,
          companyId: this.$route.query.companyId,
        },
      });
    }
  },
  beforeDestroy() {
    window.clearInterval(this.interval);
  },
  methods: {
    changeTab(tab) {
      this.tab = tab;
    },
    arrowLeft() {
      const containerLeft = document.getElementById("scoll-pane");
      this.sideScroll(containerLeft, "left", 25, 150, 10);
    },
    arrowRight() {
      var containerRight = document.getElementById("scoll-pane");
      this.sideScroll(containerRight, "right", 25, 150, 10);
    },
    sideScroll(element, direction, speed, distance, step) {
      let scrollAmount = 0;
      var slideTimer = setInterval(function () {
        if (direction == "left") {
          element.scrollLeft -= step;
        } else {
          element.scrollLeft += step;
        }
        scrollAmount += step;
        if (scrollAmount >= distance) {
          window.clearInterval(slideTimer);
        }
      }, speed);
    },
    openRouteInNewTab(name) {
      const routeData = this.$router.resolve({
        name: name,
        query: this.$route.query.branchId
          ? {
              branchId: this.$route.query.branchId,
              companyId: this.$route.query.companyId,
              dealerId: this.$route.query.dealerId,
              groupId: this.$route.query.groupId,
              regionId: this.$route.query.regionId,
              startDate: this.generalStartDate,
              endDate: this.generalEndDate,
            }
          : null,
      });

      // Open the route URL in a new tab
      window.open(routeData.href, "_blank");
    },

    fetchData() {
      this.getTankStock();
      this.getDaySalesByHour();
      this.getHistoryChartsData();
      this.getTanksProbeByHour();
      this.getPumpCount();
      // this.getPumpCalibration();
      this.getPumpsAverageTimePerLitre();
      this.getPumpsFault();
      this.getOfflinePmps();
      this.getDeviceNotPushing();
      this.getPMSTransactionCount();
      this.getAvgLtrCount();
      this.getTargetsParecentage();
      this.loadedFirst = false;
      this.getPaymentChannelsData();
      this.getRevenueData();
      // this.getDeviceNotPushing();
      // this.getPMSTransactionCount();
      // this.getAvgLtrCount();
      // this.getTargetsParecentage();
      // this.getAGOTransactionCount();
    },
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    changeRoute(route, id) {
      this.$router.push({
        name: route,
        query: { branchId: $route.query.branchId },
      });
    },
    getPumpsFault() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pumps/Faults/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.pumpsFault = response.data.length;
        })
        .catch((error) => {});
    },
    getOfflinePmps() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/BranchOfflinePumpCount/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.offlinePumps = response.data.offline;
        })
        .catch((error) => {});
    },
    getPaymentChannelsData() {
      if (this.loadedFirst == true) {
        this.loadingNT = false;
      } else {
        this.loadingNT = true;
      }
      // this.loadingNT = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/BranchPaymentChannel/${this.branchId}?startDate=${this.generalStartDate}&endDate=${this.generalEndDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response);
          this.pcbankDeposit = this.convertThousand(response.data.bankDeposit);
          this.pcdirectBankDeposit = this.convertThousand(
            response.data.directBankDeposit
          );
          this.pcpayDirectBankDeposit = this.convertThousand(
            response.data.payDirectBankDeposit
          );
          this.pccash = this.convertThousand(response.data.cash);
          this.pccurrency = response.data.currency;
          this.pcesales = this.convertThousand(response.data.esales);
          this.pcretainership = this.convertThousand(
            response.data.retainership
          );
          this.pcoutstandingCash = this.convertThousand(
            response.data.outstandingCash
          );
          this.pcposSales = this.convertThousand(response.data.posSales);
          this.loadingNT = false;
        })
        .catch((error) => {
          this.loadingNT = true;
        });
    },
    getRevenueData() {
      if (this.loadedFirst == true) {
        this.loadingNT2 = false;
      } else {
        this.loadingNT2 = true;
      }
      // this.loadingNT2 = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/BranchRevenue/${this.branchId}?startDate=${this.generalStartDate}&endDate=${this.generalEndDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response.data);
          this.pcbalance = response.data.balance;
          this.pccurrency2 = response.data.currency;
          this.pcdryStock = response.data.dryStock;
          this.pcexpenses = response.data.expenses;
          this.pcwetStock = response.data.wetStock;
          this.pcrtt = response.data.rtt;
          this.loadingNT2 = false;
        })
        .catch((error) => {
          this.loadingNT2 = true;
        });
    },
    getDeviceNotPushing() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Company/BranchDeviceNotPushingCount/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.deviceNotPushing = response.data.faultyPumps;
        })
        .catch((error) => {});
    },
    getPMSTransactionCount() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Report/ProductSalesCount/${this.branchId}?startDate=${this.generalStartDate}&endDate=${this.generalEndDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          // console.log(res.data);
          this.PMSTransactionCount = res.data[0].pmScount.toLocaleString();
          this.AGOTransactionCount = res.data[0].agOcount.toLocaleString();
          this.DPKTransactionCount = res.data[0].dpkcount.toLocaleString();
          this.LPGTransactionCount = res.data[0].lpGcount.toLocaleString();
        })
        .catch((error) => {});
    },
    getAvgLtrCount() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Report/AverageProductSale/${this.branchId}?startDate=${this.generalStartDate}&endDate=${this.generalEndDate}`,
          configObject.authConfig()
        )
        .then((res) => {
          // console.log(res.data);
          this.PMSAvgLtrCount = res.data.pmsAvgLitre.toFixed(1);
          this.AGOAvgLtrCount = res.data.agoAvgLitre.toFixed(1);
          this.DPKAvgLtrCount = res.data.dpkAvgLitre.toFixed(1);
          this.LPGAvgLtrCount = res.data.lpgAvgLitre.toFixed(1);
        })
        .catch((error) => {});
    },
    // getAGOTransactionCount() {
    //   this.axios
    //     .get(
    //       `${configObject.apiBaseUrl}/Report/ProductSales/${this.branchId}?product=AGO&startDate=${this.startDate}&endDate=${this.startDate}`,
    //       configObject.authConfig()
    //     )
    //     .then((res) => {
    //       this.AGOTransactionCount = res.data.data.length;
    //     })
    //     .catch((error) => {});
    // },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    tankStockSummary(productSummary) {
      let productName = productSummary.map((tank) => {
        return tank.name.substr(0, 3);
      });
      let finalProduct = new Set(productName);
      this.LGgridNum = `col-lg-${12 / finalProduct.size}`;
      this.MDgridNum = `col-md-${12 / finalProduct.size}`;
      let prodCount = 0;
      let summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "pms"
      );
      if (summary && summary.length > 0) {
        this.pmsTankStock = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasTankStockPms = true;
        prodCount++;
      }
      summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "ago"
      );
      if (summary && summary.length > 0) {
        this.agoTankStock = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasTankStockAgo = true;
        prodCount++;
      }
      summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "dpk"
      );
      if (summary && summary.length > 0) {
        this.dpkTankStock = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasTankStockDpk = true;
        prodCount++;
      }
      summary = productSummary.filter(
        (prod) => prod.productName.toLowerCase() == "lpg"
      );
      if (summary && summary.length > 0) {
        this.lpgTankStock = {
          volume: summary.reduce((acc, curr) => {
            return acc + curr.currentVolume;
          }, 0),
        };
        this.hasTankStockLpg = true;
        prodCount++;
      }
      prodCount++;
      let columnNumber;
      prodCount !== 5 ? (columnNumber = 12 / prodCount) : (columnNumber = 3);
      this.productCount = `col-lg-3`;
      // this.productCount = `col-lg-${columnNumber}`;
    },
    displayProductSummary(prodSummary) {
      if (prodSummary.length > 0) {
        let productCounting = 0;
        let pmsSummary = prodSummary.filter(
          (prod) =>
            prod.product.toLowerCase() ==
            this.countryProducts.productsLower.product1
        );
        if (pmsSummary.length) {
          productCounting++;
          this.pmsSummary = pmsSummary[0];
        }
        let agoSummary = prodSummary.filter(
          (prod) =>
            prod.product.toLowerCase() ==
            this.countryProducts.productsLower.product2
        );
        if (agoSummary.length) {
          productCounting++;
          this.agoSummary = agoSummary[0];
        }
        let dpkSummary = prodSummary.filter(
          (prod) =>
            prod.product.toLowerCase() ==
            this.countryProducts.productsLower.product3
        );
        if (dpkSummary.length) {
          productCounting++;
          this.dpkSummary = dpkSummary[0];
        }
        let lpgSummary = prodSummary.filter(
          (prod) =>
            prod.product.toLowerCase() ==
            this.countryProducts.productsLower.product4
        );
        if (lpgSummary.length) {
          productCounting++;
          this.lpgSummary = lpgSummary[0];
        }

        this.prodCounts = productCounting;
        // console.log(productCounting);
        let total = prodSummary.reduce((acc, curr) => {
          return acc + curr.volume;
        }, 0);
        let p = parseFloat(
          this.decimalThousand((this.pmsSummary.volume / total) * 100)
        );
        let a = parseFloat(
          this.decimalThousand((this.agoSummary.volume / total) * 100)
        );
        let d = parseFloat(
          this.decimalThousand((this.dpkSummary.volume / total) * 100)
        );
        let l = parseFloat(
          this.decimalThousand((this.lpgSummary.volume / total) * 100)
        );
        this.donutSeries = [a, d, p, l];
        this.chartOptions = {
          ...this.chartOptions,
          labels: [
            this.countryProducts.products.product2,
            this.countryProducts.products.product3,
            this.countryProducts.products.product1,
            this.countryProducts.products.product4,
          ],
        };
      }
    },
    getPumpsAverageTimePerLitre() {
      let grid = this.$refs.dataGrid;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pumps/BranchAverageTimePerLiter/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          const totalAverageTimePerLitre = response.data.reduce((acc, cur) => {
            return acc + cur.averageTimePerLiter;
          }, 0);
          let timeCount = 0;
          response.data.forEach((el) => {
            if (el.averageTimePerLiter > 0) {
              timeCount++;
            }
          });
          const averageTime = totalAverageTimePerLitre / timeCount;
          if (Number.isNaN(averageTime)) {
            this.pumpsAverageTimePerLiterCount = 0;
          } else {
            this.pumpsAverageTimePerLiterCount = averageTime.toFixed(2);
          }
        })
        .catch((error) => {});
    },
    getProductSummary() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/DaySale/${this.branchId}?startDate=${this.generalStartDate}&endDate=${this.generalEndDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          const dayDifferences = {};

          response.data.forEach((item) => {
            const { product, volume, lastSalesDate, date } = item;

            // NEW CONDITIONAL FOR DISPLAYING FIRST CARD GRAPH
            const lastSales = new Date(lastSalesDate);
            const currentDate = new Date(date);
            const timeDifference = currentDate - lastSales;
            const daysDifference = Math.floor(
              timeDifference / (1000 * 60 * 60 * 24)
            );

            dayDifferences[product] = {
              daysDifference,
              volume,
            };
          });

          if (
            dayDifferences.PMS &&
            dayDifferences.PMS.daysDifference > 30 &&
            dayDifferences.PMS.volume == 0
          ) {
            // this.pmsCond = true;
          }
          if (
            dayDifferences.AGO &&
            dayDifferences.AGO.daysDifference > 30 &&
            dayDifferences.AGO.volume == 0
          ) {
            // this.agoCond = true;
          }
          if (
            dayDifferences.DPK &&
            dayDifferences.DPK.daysDifference > 30 &&
            dayDifferences.DPK.volume == 0
          ) {
            // this.dpkCond = true;
          }
          if (
            dayDifferences.LPG &&
            dayDifferences.LPG.daysDifference > 30 &&
            dayDifferences.LPG.volume == 0 &&
            this.prodCounts == 4
          ) {
            this.lpgCond = true;
          }

          // console.log(dayDifferences);
          this.displayProductSummary(response.data);
          this.showLoader = false;
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getTargetsParecentage() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Target/BranchSales/${this.branchId}/${this.startDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response);
          this.showLoader = false;
          let productCounting = 0;
          let pmsArray = response.data.filter(
            (prod) => prod.product === this.countryProducts.products.product1
          );
          let PMS;
          if (pmsArray.length) {
            productCounting++;
            PMS = pmsArray[0];
          } else {
            PMS = { dayPercent: 0 };
          }
          let agoArray = response.data.filter(
            (prod) => prod.product === this.countryProducts.products.product2
          );
          let AGO;
          if (agoArray.length) {
            productCounting++;
            AGO = agoArray[0];
          } else {
            AGO = { dayPercent: 0 };
          }
          let dpkArray = response.data.filter(
            (prod) => prod.product === this.countryProducts.products.product3
          );
          let DPK;
          if (dpkArray.length) {
            productCounting++;
            DPK = dpkArray[0];
          } else {
            DPK = { dayPercent: 0 };
          }
          let lpgArray = response.data.filter(
            (prod) => prod.product === this.countryProducts.products.product4
          );
          let LPG;
          if (lpgArray.length) {
            productCounting++;
            LPG = lpgArray[0];
          } else {
            LPG = { dayPercent: 0 };
          }

          this.prodCounts = productCounting;
          // console.log(this.prodCounts);

          // NEW SALES VS TARGET GRAPH
          let pmsSeries = pmsArray.length
            ? [
                {
                  name: this.countryProducts.products.product1,
                  y: parseFloat(this.convertThousand(PMS.dayPercent)),
                  color: "#D8991C",
                },
              ]
            : [];
          let agoSeries = agoArray.length
            ? [
                {
                  name: this.countryProducts.products.product2,
                  y: parseFloat(this.convertThousand(AGO.dayPercent)),
                  color: "#6CC066",
                },
              ]
            : [];
          let dpkSeries = dpkArray.length
            ? [
                {
                  name: this.countryProducts.products.product3,
                  y: parseFloat(this.convertThousand(DPK.dayPercent)),
                  color: "#1864AB",
                },
              ]
            : [];
          let lpgSeries = lpgArray.length
            ? [
                {
                  name: this.countryProducts.products.product4,
                  y: parseFloat(this.convertThousand(LPG.dayPercent)),
                  color: "#820080",
                },
              ]
            : [];

          this.NewSalesTarget.series = [
            {
              name: "Product",
              data: [...pmsSeries, ...agoSeries, ...dpkSeries, ...lpgSeries],
            },
          ];

          // console.log(this.NewSalesTarget.series);
          this.pmsGuageOptions.series[0].data[0].y = pmsArray.length
            ? parseFloat(this.convertThousand(PMS.dayPercent))
            : [];
          this.agoGuageOptions.series[0].data[0].y = agoArray.length
            ? parseFloat(this.convertThousand(AGO.dayPercent))
            : [];
          this.dpkGuageOptions.series[0].data[0].y = dpkArray.length
            ? parseFloat(this.convertThousand(DPK.dayPercent))
            : [];
          this.lpgGuageOptions.series[0].data[0].y = lpgArray.length
            ? parseFloat(this.convertThousand(LPG.dayPercent))
            : [];
        })
        .catch((error) => {});
    },
    getPumpCount() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/Branch/PumpCount/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          this.pumpsCount = response.data.pumpCount;
        })
        .catch((error) => {});
    },
    getPumpCalibration() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Pumps/Calibration/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          if (Array.isArray(response.data)) {
            let totalCalibratonRatio = response.data.reduce((acc, cur) => {
              acc += parseFloat(cur.calibrationRatio);
              return acc;
            }, 0);
            let averageCalibrationRatio =
              totalCalibratonRatio / response.data.length;
            this.averagePumpsCalibrationRatio = this.convertThousand(
              averageCalibrationRatio
            );
            this.calibrationType = "array";
            return;
          } else {
            this.pumpsCalibration = response.data;
            this.calibrationType = "number";
          }
        })
        .catch((error) => {});
    },
    getTankCount() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/Branch/TankCount/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.tanksCount = response.data.tankCount;
        })
        .catch((error) => {});
    },
    getTanksFilled() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Dashboard/BranchTanksFilled/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.tanksFilled = response.data;
        })
        .catch((error) => {});
    },
    getTankStock() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Tanks/${this.branchId}?startDate=${this.generalStartDate}&endDate=${this.generalEndDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.tankStockSummary(response.data);
          this.showLoader = false;
          const groups = response.data.reduce((groups, sales) => {
            const branchName = sales.branchName;
            if (!groups[branchName]) {
              groups[branchName] = [];
            }
            groups[branchName].push(sales);
            return groups;
          }, {});
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
    getTanks() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/Tanks/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.tanksCount = response.data.length;
          response.data.forEach((element) => {
            element.height = parseInt(
              150 - (element.currentVolume / element.maxCapacity) * 140
            );
            if (element.height >= 98) {
              element.color = "red";
            } else if (element.height >= 70) {
              element.color = "#039be4";
            } else {
              element.color = "green";
            }
            element.waterVolume =
              element.waterVolume == null ? 0 : element.waterVolume;
          });
          response.data.sort(function (a, b) {
            return a.height - b.height;
          });
          this.tanks = response.data.filter((tk) => tk.hasATG);
          // console.log(this.tanks);
        })
        .catch((error) => {});
    },
    // showAddEmailToBranchModal() {
    //   this.$modal.show("emailToBranch");
    // },
    getHistoryChartsData() {
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/FiveDaySale/${this.branchId}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          response.data.forEach((el) => {
            if (
              el.product.toLowerCase() ===
              this.countryProducts.productsLower.product4
            ) {
              this.availableProducts.push(
                this.countryProducts.productsLower.product4
              );
              this.hasLpg = true;
            } else if (
              el.product.toLowerCase() ===
              this.countryProducts.productsLower.product1
            ) {
              this.availableProducts.push(
                this.countryProducts.productsLower.product1
              );
              this.hasPms = true;
            } else if (
              el.product.toLowerCase() ===
              this.countryProducts.productsLower.product2
            ) {
              this.availableProducts.push(
                this.countryProducts.productsLower.product2
              );
              this.hasAgo = true;
            } else {
              this.availableProducts.push(
                this.countryProducts.productsLower.product3
              );
              this.hasDpk = true;
            }
          });
          let uniqueList = [...new Set(this.availableProducts)];
          this.availableProducts = uniqueList;
          let productsLength = this.availableProducts.length;
          let targetsColNum = productsLength == 4 ? 3 : 4;
          this.salesTargetCount = `col-lg-${targetsColNum}`;
          this.getting = false;
          this.paintSplineData(response.data);
        })
        .catch((error) => {});
    },
    getDaySalesByHour() {
      this.showHourlySalesLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Branch/DaySalesByHour/${this.branchId}?date=${this.hourlyTransactionsDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showHourlySalesLoader = false;
          if (response.data.length > 0) {
            let splineData = response.data;
            // Pump
            let series = [];
            let pms = splineData.filter(
              (trans) =>
                trans.product.toLowerCase() ===
                  this.countryProducts.productsLower.product1 &&
                trans.type === "Pump"
            );
            let pmsValueArray = [];
            pms.forEach((element) => {
              pmsValueArray.push(parseFloat(element.volume.toFixed(2)));
            });
            series.push({
              name: `${this.countryProducts.products.product1} ${this.$t(
                "text.endOfDayReport.pumpSales"
              )}`,
              data: pmsValueArray,
              color: "#d8991c",
            });
            let ago = splineData.filter(
              (trans) =>
                trans.product.toLowerCase() ===
                  this.countryProducts.productsLower.product2 &&
                trans.type === "Pump"
            );
            let agoValueArray = [];
            ago.forEach((element) => {
              agoValueArray.push(parseFloat(element.volume.toFixed(2)));
            });
            series.push({
              name: `${this.countryProducts.products.product2} ${this.$t(
                "text.endOfDayReport.pumpSales"
              )}`,
              data: agoValueArray,
              color: "#0fce29",
            });
            let dpk = splineData.filter(
              (trans) =>
                trans.product.toLowerCase() ===
                  this.countryProducts.productsLower.product3 &&
                trans.type === "Pump"
            );
            let dpkValueArray = [];
            dpk.forEach((element) => {
              dpkValueArray.push(parseFloat(element.volume.toFixed(2)));
            });
            series.push({
              name: `${this.countryProducts.products.product3} ${this.$t(
                "text.endOfDayReport.pumpSales"
              )}`,
              data: dpkValueArray,
              color: "#00aced",
            });
            let lpg = splineData.filter(
              (trans) =>
                trans.product.toLowerCase() ===
                  this.countryProducts.productsLower.product4 &&
                trans.type === "Pump"
            );
            let lpgValueArray = [];
            if (lpg.length) {
              lpg.forEach((element) => {
                lpgValueArray.push(parseFloat(element.volume.toFixed(2)));
              });
              series.push({
                name: `${this.countryProducts.products.product4} ${this.$t(
                  "text.endOfDayReport.pumpSales"
                )}`,
                data: lpgValueArray,
                color: "rgb(233, 141, 233)",
              });
            }
            // Tanks
            let pmsTank = splineData.filter(
              (trans) =>
                trans.product.toLowerCase() ===
                  this.countryProducts.productsLower.product1 &&
                trans.type === "Tank"
            );
            let pmsTankValueArray = [];
            pmsTank.forEach((element) => {
              pmsTankValueArray.push(parseFloat(element.volume.toFixed(2)));
            });
            series.push({
              name: `${this.countryProducts.products.product1} ${this.$t(
                "text.sales.tankSales"
              )}`,
              data: pmsTankValueArray,
              color: "#6e4d06",
            });
            let agoTank = splineData.filter(
              (trans) =>
                trans.product.toLowerCase() ===
                  this.countryProducts.productsLower.product2 &&
                trans.type === "Tank"
            );
            let agoTankValueArray = [];
            agoTank.forEach((element) => {
              agoTankValueArray.push(parseFloat(element.volume.toFixed(2)));
            });
            series.push({
              name: `${this.countryProducts.products.product2} ${this.$t(
                "text.sales.tankSales"
              )}`,
              data: agoTankValueArray,
              color: "#045f10",
            });
            let dpkTank = splineData.filter(
              (trans) =>
                trans.product.toLowerCase() ===
                  this.countryProducts.productsLower.product3 &&
                trans.type === "Tank"
            );
            let dpkTankValueArray = [];
            dpkTank.forEach((element) => {
              dpkTankValueArray.push(parseFloat(element.volume.toFixed(2)));
            });
            series.push({
              name: `${this.countryProducts.products.product3} ${this.$t(
                "text.sales.tankSales"
              )}`,
              data: dpkTankValueArray,
              color: "#05435a",
            });
            let lpgTank = splineData.filter(
              (trans) =>
                trans.product.toLowerCase() ===
                  this.countryProducts.productsLower.product4 &&
                trans.type === "Tank"
            );
            let lpgTankValueArray = [];
            if (lpgTank.length) {
              lpgTank.forEach((element) => {
                lpgTankValueArray.push(parseFloat(element.volume.toFixed(2)));
              });
              series.push({
                name: `${this.countryProducts.products.product4} ${this.$t(
                  "text.sales.tankSales"
                )}`,
                data: lpgTankValueArray,
                color: "purple",
              });
            }
            series.sort((a, b) =>
              a.name.toLowerCase() < b.name.toLowerCase()
                ? -1
                : a.name.toLowerCase() > b.name.toLowerCase()
                ? 1
                : 0
            );
            const timeCats = [
              ...new Set(
                splineData.map((x) =>
                  this.$moment(x.date).subtract(1, "hours").format("h:mm A")
                )
              ),
            ];
            this.hourlySalesSplineOptions.xAxis.categories = timeCats;
            // this.hourlySalesSplineOptions.series = [...series, ...this.hourlySalesSplineOptions.series];
            this.hourlySalesSplineOptions.series = series;
          }
        })
        .catch((error) => {
          this.showHourlySalesLoader = false;
        });
    },
    getTanksProbeByHour() {
      this.productStockHourlySalesLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Tank/TanksHourlyProbe/${this.branchId}?date=${this.tankStartDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.productStockHourlySalesLoader = false;
          if (response.data.length > 0) {
            // let splineData = response.data;
            // let series = [];
            // const myObject = response.data.reduce((obj, cur) => {
            //   const name = cur.productName
            //   const date = cur.date
            //   if (name in obj) {
            //     obj[name] = {
            //       ...obj[name],
            //       [date]: obj[name][date] ? (obj[name][date] + cur.productVolume) : cur.productVolume
            //     }
            //   }
            //   else {
            //     obj[name] = {
            //       [date]: cur.productVolume
            //     }
            //   }
            //   return obj
            // }, {})
            // function makeArray(obj) {
            //   let arr = []
            //   for(var x in obj) {
            //     arr.push(obj[x])
            //   }
            //   return arr.reverse()
            // }
            // for(var name in myObject) {
            //   const productName = name.toLowerCase()
            //   series.push({
            //     name,
            //     data: makeArray(myObject[name]),
            //     color: productName == this.countryProducts.productsLower.product1 ? '#d8991c' : productName == this.countryProducts.productsLower.product2 ? '#0fce29' : '#00aced'
            //   });
            // }
            const ids = new Set(response.data.map((cur) => cur.tankName));
            let splineData = response.data;
            let series = [];
            splineData.forEach((cur) => {
              ids.forEach((current) => {
                const index = series.findIndex((sery) => sery.name == current);
                if (index == -1 && cur.tankName == current) {
                  series.push({
                    name: current,
                    data: [parseFloat(cur.productVolume.toFixed(2))],
                  });
                }
                if (index != -1 && cur.tankName == current) {
                  const value = series[index].data;
                  series[index].data = [
                    ...value,
                    parseFloat(cur.productVolume.toFixed(2)),
                  ];
                }
              });
            });
            series.forEach((cur) => {
              cur.data = cur.data.reverse();
            });
            series.sort((a, b) =>
              a.name.toLowerCase() < b.name.toLowerCase()
                ? -1
                : a.name.toLowerCase() > b.name.toLowerCase()
                ? 1
                : 0
            );
            const timeCats = [
              ...new Set(
                splineData.map((x) =>
                  this.$moment(x.date)
                    // .subtract(1, "hours")
                    .format("h:mm A")
                )
              ),
            ];
            this.productStockHourlySplineOptions.xAxis.categories =
              timeCats.reverse();
            this.productStockHourlySplineOptions.series = series;
          }
        })
        .catch((error) => {
          this.productStockHourlySalesLoader = false;
        });
    },
    paintSplineData(splineData) {
      if (splineData.length > 0) {
        //PMS
        let pms = splineData.filter(
          (trans) =>
            trans.product.toLowerCase() ===
            this.countryProducts.productsLower.product1
        );
        let pmsValueArray = [];
        pms.forEach((element) => {
          pmsValueArray.push(element.volume);
        });
        const label = pms.map((cur) =>
          cur.date.split("T")[0].split("-").reverse().join("-")
        );
        let length = pmsValueArray.length;
        let curr = pmsValueArray[length - 1];
        let prev = pmsValueArray[length - 2];
        this.pmsRate = parseFloat(((curr - prev) / prev) * 100).toFixed(1);
        this.pmsRate = !isFinite(this.pmsRate) ? 0.0 : this.pmsRate;
        if (this.pmsRate < 0) {
          this.pmsUp = false;
          this.pmsRateColor = "red";
        } else {
          this.pmsUp = true;
          this.pmsRateColor = "green";
        }
        this.pmsRate = Math.abs(this.pmsRate);
        let pmsSeries = new Array({ name: "", data: pmsValueArray });
        this.pmsSplineOption.series = pmsSeries;
        this.pmsSplineOption.series[0].color = "#d8991c";
        this.pmsSplineOption.xAxis.categories = label;
        //AGO
        let ago = splineData.filter(
          (trans) =>
            trans.product.toLowerCase() ===
            this.countryProducts.productsLower.product2
        );
        let agoValueArray = [];
        ago.forEach((element) => {
          agoValueArray.push(element.volume);
        });
        length = pmsValueArray.length;
        curr = agoValueArray[length - 1];
        prev = agoValueArray[length - 2];
        this.agoRate = parseFloat(((curr - prev) / prev) * 100).toFixed(1);
        this.agoRate = !isFinite(this.agoRate) ? 0.0 : this.agoRate;
        if (this.agoRate < 0) {
          this.agoUp = false;
          this.agoRateColor = "red";
        } else {
          this.agoUp = true;
          this.agoRateColor = "green";
        }
        this.agoRate = Math.abs(this.agoRate);
        let agoSeries = new Array({ name: "", data: agoValueArray });
        this.agoSplineOption.series = agoSeries;
        this.agoSplineOption.series[0].color = "#0fce29";
        this.agoSplineOption.xAxis.categories = label;
        //DPK
        let dpk = splineData.filter(
          (trans) =>
            trans.product.toLowerCase() ===
            this.countryProducts.productsLower.product3
        );
        let dpkValueArray = [];
        dpk.forEach((element) => {
          dpkValueArray.push(element.volume);
        });
        length = pmsValueArray.length;
        curr = dpkValueArray[length - 1];
        prev = dpkValueArray[length - 2];
        this.dpkRate = parseFloat(((curr - prev) / prev) * 100).toFixed(1);
        this.dpkRate = !isFinite(this.dpkRate) ? 0.0 : this.dpkRate;
        if (this.dpkRate < 0) {
          this.dpkUp = false;
          this.dpkRateColor = "red";
        } else {
          this.dpkUp = true;
          this.dpkRateColor = "green";
        }
        this.dpkRate = Math.abs(this.dpkRate);
        let dpkSeries = new Array({ name: "", data: dpkValueArray });
        this.dpkSplineOption.series = dpkSeries;
        this.dpkSplineOption.series[0].color = "#00aced";
        this.dpkSplineOption.xAxis.categories = label;
        //LPG
        let lpg = splineData.filter(
          (trans) =>
            trans.product.toLowerCase() ===
            this.countryProducts.productsLower.product4
        );
        let lpgValueArray = [];
        lpg.forEach((element) => {
          lpgValueArray.push(element.volume);
        });
        length = pmsValueArray.length;
        curr = lpgValueArray[length - 1];
        prev = lpgValueArray[length - 2];
        this.lpgRate = parseFloat(((curr - prev) / prev) * 100).toFixed(1);
        this.lpgRate = !isFinite(this.lpgRate) ? 0.0 : this.lpgRate;
        if (this.lpgRate < 0) {
          this.lpgUp = false;
          this.lpgRateColor = "red";
        } else {
          this.lpgUp = true;
          this.lpgRateColor = "green";
        }
        this.lpgRate = Math.abs(this.lpgRate);
        let lpgSeries = new Array({ name: "", data: lpgValueArray });
        this.lpgSplineOption.series = lpgSeries;
        this.lpgSplineOption.series[0].color = "#80008026";
        this.lpgSplineOption.xAxis.categories = label;
        //TOTAL
        const groups = splineData.reduce((groups, product) => {
          const date = product.date.split("T")[0];
          if (!groups[date]) {
            groups[date] = [];
          }
          groups[date].push(product);
          return groups;
        }, {});
        const groupArrays = Object.keys(groups).map((date) => {
          return {
            date,
            volume: groups[date].reduce((acc, currValue) => {
              return acc + currValue.volume;
            }, 0),
          };
        });
        let totalValueArray = [];
        groupArrays.forEach((element) => {
          totalValueArray.push(element.volume);
        });
        length = totalValueArray.length;
        curr = totalValueArray[length - 1];
        prev = totalValueArray[length - 2];
        this.totalRate = parseFloat(((curr - prev) / prev) * 100).toFixed(1);
        this.totalRate = !isFinite(this.totalRate) ? 0.0 : this.totalRate;
        if (this.totalRate < 0) {
          this.totalUp = false;
          this.totalRateColor = "red";
        } else {
          this.totalUp = true;
          this.totalRateColor = "green";
        }
        this.totalRate = Math.abs(this.totalRate);
        let totalSeries = new Array({ name: "", data: totalValueArray });
        this.totalSplineOption.series = totalSeries;
        this.totalSplineOption.series[0].color = "#ff7c71";
        this.totalSplineOption.xAxis.categories = label;
      }
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    toggleShowAll(event) {
      if (this.showAll === true) {
        this.showAll = false;
        event.target.innerHTML = "Show All";
      } else {
        this.showAll = true;
        event.target.innerHTML = "Show Less";
      }
    },
    decimalThousand(number) {
      if (!isFinite(number)) {
        return "0.00";
      }
      return number
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
};
</script>
<style scoped>
.date-picker {
  width: 98%;
  margin: auto;
}
.date-picker .drop_down_div {
  width: 35%;
}
.drop_down_div {
  width: 35%;
}
.dashboard_left {
  margin-top: 34px !important;
}
.loading {
  width: 102% !important;
  border-radius: 10px;
}
@media only screen and (max-width: 500px) {
  .date-picker .drop_down_div {
    width: 60%;
  }
  .drop_down_div {
    width: 54%;
  }
  .daily_count {
    margin-top: -200px !important;
    height: 300px;
    margin-bottom: 70px !important;
  }
}

.remisAD {
  width: 98% !important;
  margin: auto;

  object-fit: fill;
}

.arrowpics:hover {
  width: 50px;
}

.arrow-div-left {
  top: 200px;
  cursor: pointer;
  display: none;
}
.arrow-div-right {
  top: 200px;
  right: 20px;
  cursor: pointer;
  display: none;
}

@media screen and (min-width: 780px) {
  .scoll-pane {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;
    height: auto;
    overflow: auto;
    outline: none;
    overflow-y: hidden;
    -ms-overflow-style: scroll;
    scrollbar-width: none;
  }

  .scoll-pane::-webkit-scrollbar {
    display: none;
  }

  .arrow-div-left,
  .arrow-div-right {
    display: block !important;
  }
}

@media screen and (max-width: 780px) {
  .remisAD {
    margin-top: -100px;
  }
  .mobMarg {
    margin-top: 1px !important;
  }
}

@media screen and (max-width: 600px) {
  .remisAD {
    height: 110px !important;
    margin-top: -20px;
  }
}
</style>
